<template>
  <div>
    <div class="leaderBox" v-if="showOrhide">
      <div class="newtext">新手指引</div>
      <img src="../../assets/images/maskClose.png" class="closeIt" @click="closeIt">
      <img src="../../assets/images/pop/dd/dingd.jpg" class="createNxs createNx1" v-if="status==1">
      <div class="createNxbtn" @click="nextcreateNx(status)">
        {{ status == 1 ? "我知道了" : "我知道了" }}
      </div>
      <div class="bottomTip">
        <el-checkbox v-model="checked">下次不再提示</el-checkbox>
      </div>
    </div>
    <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'创建订单'}]" />
    <!---------------------------------------------------项目信息-------------------------------------------------------------------->
    <div class="h-piece" style="margin:20px">
      <div class="h-pieceIn2 n-xiao" v-if="order.orderProjectCode && order.category1Name != '工程订单'">
        <div class="h-pieceTitle2 " style="margin-left:10px">
          <h1>项目信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine">
            <el-form :model="order" label-position="right" :inline="true" class="demo-ruleForm h-formbLine">
              <el-form-item label="项目名称" class="h-elformWrap-2">
                <el-input v-model="order.orderProjectName" readonly></el-input>
              </el-form-item>
              <el-form-item label="项目版本号" class="h-elformWrap-2">
                <el-input v-model="order.orderProjectCode" readonly></el-input>
              </el-form-item>
              <el-form-item v-if="contractflag" label="项目合同编号" class="h-elformWrap-2">
                <el-input v-model="order.orderSubContract" readonly></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-------------------------------------------------------项目信息-------------------------------------------------------------------->
      <!-- 合同信息 -->
      <!--<div class="h-pieceIn2" v-if="showRent && !showJzx">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>合同信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form label-position="right" :inline="true" ref="form0" :model="order"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="关联合同" class="h-elformWrap-2">
                                <el-input v-model="contract.contractName" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="合同开始时间" class="h-elformWrap-2">
                                <el-input v-model="contract.contractStarttime" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="合同结束时间" class="h-elformWrap-2">
                                <el-input v-model="contract.contractEndtime" readonly></el-input>
                            </el-form-item>
                            <el-form-item label="收益分摊周期" class="h-elformWrap-2">
                                <el-input v-model="order.zsyzq" readonly></el-input>
                            </el-form-item>
                        </el-form>
                    </div>
                </div>
            </div>-->
      <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

      <div class="h-pieceIn2">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>订单信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form label-position="right" :inline="true" ref="form0" :model="order" class="demo-ruleForm h-formbLine">
              <el-form-item label="项目名称" class="h-elformWrap-2" v-if="order.category1Name == '工程订单'">
                <el-input v-model="order.orderProjectName" readonly></el-input>
              </el-form-item>
              <el-form-item label="项目版本号" class="h-elformWrap-2" v-if="order.category1Name == '工程订单'">
                <el-input v-model="order.orderProjectCode" readonly></el-input>
              </el-form-item>
              <el-form-item label="项目备注" class="h-elformWrap-2" v-if="order.category1Name == '工程订单'">
                <el-input v-model="order.projectDescription" :title="order.projectDescription" readonly></el-input>
              </el-form-item>
              <el-form-item label="订单类型" class="h-elformWrap-2">
                <el-input v-model="xsqyStr" readonly></el-input>
              </el-form-item>
              <el-form-item label="创建人" class="h-elformWrap-2">
                <el-input v-model="this.order.cuname" readonly></el-input>
              </el-form-item>
              <el-form-item label="创建时间" class="h-elformWrap-2">
                <el-input v-model="this.order.cdate" readonly></el-input>
              </el-form-item>
              <el-form-item label="订购原因" prop="businessReason" class="h-elformWrap-2" v-if="showIsFree" :rules="[
							  { required: true, message: '请选择订购原因', trigger: 'change'},
							]">
                <brselect clearable category="business_reason" :v="order.businessReason" v-model="order.businessReason"></brselect>
              </el-form-item>
              <el-form-item label="业务原因" prop="businessReason" class="h-elformWrap-2" v-if="showRent" :rules="[
								  { required: true, message: '请选择业务原因', trigger: 'blur'},
								]">
                <brselect clearable category="business_reason" :v="order.businessReason" v-model="order.businessReason"></brselect>
              </el-form-item>
              <!--
                            <el-form-item prop="note" label="备注" :rules="[
                                  {  max: 30, message: '长度在30个字符以内', trigger: 'blur' }
                                ]" class="h-elformWrap-2">
                                <el-input v-model="order.note" placeholder="请输入"></el-input>
                            </el-form-item>
                            -->

              <el-form-item label="样品机合同" class="h-elformWrap-2" v-if="showSampleHetong">
                <brupload :refid=order.id reftype="样品机合同" :limit="1" :showtime="false" uploadflag delflag>
                </brupload>
              </el-form-item>

            </el-form>
          </div>
        </div>
      </div>
      <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

      <!-------------------------------------------------------项目信息-------------------------------------------------------------------->
      <!-- 合同信息 -->
      <div class="h-pieceIn2" v-if="showJzx">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>合同信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form label-position="right" :inline="true" ref="form0" :model="order" class="demo-ruleForm h-formbLine">
              <el-form-item label="合同名称" class="h-elformWrap-2">
                <el-input v-model="contract.contractName" readonly></el-input>
              </el-form-item>
              <el-form-item label="合同类型" class="h-elformWrap-2">
                <el-input readonly v-model="contract.contractCatecoryName"></el-input>
              </el-form-item>
              <el-form-item label="租赁类型" class="h-elformWrap-2" prop="zltype">
                <el-select v-model="contract.zltype" placeholder="请选择" :clearable="true" filterable disabled style="width:100%">
                  <el-option label="房屋" value="1"></el-option>
                  <el-option label="疫苗车" value="2"></el-option>
                  <el-option label="集装箱" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="客户名称" class="h-elformWrap-2">
                <el-input v-model="contract.customerName" readonly></el-input>
              </el-form-item>
              <el-form-item label="租赁方式" class="h-elformWrap-2" prop="rentType">
                <el-select v-model="contract.rentType" placeholder="请选择" :clearable="true" filterable disabled style="width:100%">
                  <el-option label="Round Trip" value="roundtrip"></el-option>
                  <el-option label="长期" value="longterm"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="租赁天数" class="h-elformWrap-2">
                <el-input readonly v-model="contract.rentTime"></el-input>
              </el-form-item>
              <el-form-item label="合同开始时间" class="h-elformWrap-2">
                <el-input v-model="contract.contractStarttime" readonly></el-input>
              </el-form-item>
              <el-form-item label="合同结束时间" class="h-elformWrap-2">
                <el-input v-model="contract.contractEndtime" readonly></el-input>
              </el-form-item>
              <el-form-item label="是否附加损坏豁免" class="h-elformWrap-2" prop="isShhm">
                <el-select v-model="contract.isShhm" placeholder="请选择" :clearable="true" filterable disabled style="width:100%">
                  <el-option label="是" value=1></el-option>
                  <el-option label="否" value=0></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="提箱地点" class="h-elformWrap-2">
                <el-input v-model="contract.rentPlace" readonly></el-input>
              </el-form-item>
              <el-form-item label="还箱地点" class="h-elformWrap-2">
                <el-input v-model="contract.returnPlace" readonly></el-input>
              </el-form-item>
              <el-form-item label="是否加急" class="h-elformWrap-2" prop="isJj">
                <el-select v-model="contract.isJj" placeholder="请选择" :clearable="true" filterable disabled style="width:100%">
                  <el-option label="是" value=1></el-option>
                  <el-option label="否" value=0></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单是否变更" class="h-elformWrap-2" prop="isChange">
                <el-select v-model="order.isChange" placeholder="请选择" :clearable="true" filterable style="width:100%">
                  <el-option label="是" value=1></el-option>
                  <el-option label="否" value=0></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单是否取消" class="h-elformWrap-2" prop="isCancel">
                <el-select v-model="order.isCancel" placeholder="请选择" :clearable="true" filterable style="width:100%">
                  <el-option label="是" value=1></el-option>
                  <el-option label="否" value=0></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="实际还箱日期" class="h-elformWrap-2" width="100%" prop="rentDate">
                <div class="block">
                  <el-date-picker v-model="order.returnTime" type="date" :clearable="false" value-format="yyyy-MM-dd" placeholder="请选择实际还箱日期">
                  </el-date-picker>
                </div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

      <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
      <div class="h-pieceIn2">
        <div class="h-pieceTitle2" style="margin-left:10px">
          <h1>客户信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form :model="order" ref="form1" label-position="right" :inline="true" class="demo-ruleForm h-formbLine">
              <el-form-item prop="soldToName" label="售达方名称" :rules="[
								  { required: true, message: '请输入售达方名称', trigger:['change', ' blur','input']},
								]" class="h-elformWrap-2">
                <el-input v-model="order.soldToName" placeholder="请输入" readonly>
                  <i v-if="selectDailishang" class="el-icon-search el-input__icon" slot="suffix" @click="openShoudf">
                  </i>
                </el-input>
              </el-form-item>
              <el-form-item prop="soldToAreaName" label="售达方区域" class="h-elformWrap-2" v-if="!showIsFree">
                <el-input v-model="order.soldToAreaName" readonly placeholder="自带出"></el-input>
              </el-form-item>
              <el-form-item label="售达方销售区域" class="h-elformWrap-2" v-if="!showIsFree&&!showRent">
                <el-input v-model="order.salesregionName" readonly placeholder="自带出"></el-input>
              </el-form-item>
              <el-form-item prop="customerChannelCode" label="客户渠道" :rules="[
								  { required: true, message: '请输入客户渠道', trigger:['change', ' blur','input']},
								]" class="h-elformWrap-2">
                <el-select v-model="order.customerChannelCode" placeholder="请选择" @change="cleanOrder()" style="width:100%">
                  <el-option v-for="item in customerChannelListFilter" :key="item.code" :label="item.name" :value="item.code">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item prop="isStockUp" label="是否备货" :rules="[
								  { required: true, message: '请输入是否备货', trigger: 'change'},
								]" class="h-elformWrap-2" v-if="!showIsFree&&!showRent">
                <brselect clearable category="shifou_keyong" :v="order.isStockUp" v-model="order.isStockUp"></brselect>
              </el-form-item>
              <!--                            <el-form-item prop="toCompanyname" label="收货单位"  class="h-elformWrap-2" :clearable="true">
                                &lt;!&ndash;                                <el-input v-model="order.toCompanyname" placeholder="请输入"></el-input>&ndash;&gt;
                                <el-input v-model="order.toCompanyname"  v-if="order.selectFlag" :v="order.toCompanyname"></el-input>
                                <el-select v-model="order.toCompanyname" style="width:165px" :v="order.toCompanyname" v-if="!order.selectFlag" filterable remote
                                           placeholder="请输入"
                                           :remote-method="showFormList" @change="showForm">
                                    <el-option v-for="(item) in addrList"
                                               :key="item.id"
                                               :label="item.deptName"
                                               :value="item.deptName">
                                    </el-option>
                                </el-select>
                            </el-form-item>-->
              <el-form-item label="收货单位" prop="toCompanyname" class="h-elformWrap-z" :clearable="true" :rules="[
								  { required: true, message: '请输入选择单位', trigger: 'blur'},
								]">
                <el-select v-model="order.toCompanyname" remote filterable :filter-method="showFormList" style="width:165px" :v="order.toCompanyname" clearable placeholder="请输入" :remote-method="showFormList">
                  <el-option v-for="(item) in addrList" :key="item.id" :label="item.deptName" :value="item.deptName">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item class="h-elformWrap-m" :clearable="true">
                <i class="el-icon-circle-plus" @click="createAddress"></i>
              </el-form-item>
              <el-form-item prop="contactName" label="收货联系人" :rules="[
								  { required: true, message: '请输入收货联系人', trigger: 'blur'},
								]" class="h-elformWrap-2">
                <el-input v-model="order.contactName" placeholder="请输入"></el-input>
              </el-form-item>
              <!--                            <el-form-item prop="toAddress" label="收货地址" :rules="[
								  { required: true, message: '请输入收货地址', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                <el-input v-model="order.toAddress" placeholder="请输入"></el-input>
                            </el-form-item>-->
              <el-form-item label="选择收货地址" readonly :rules="[{ required: true, message: '请输入选择收货地址', trigger:['change', ' blur','input']},]" prop="toAddress" class="h-elformWrap-2">
                <el-input clearable v-model="order.toAddress" readonly style="width:100%;">
                  <i class="el-icon-search el-input__icon" slot="suffix" @click="selectAreadialog">
                  </i>
                </el-input>
              </el-form-item>

              <el-form-item label="联系电话" width="300" :rules="[
								  { required: true, message: '请输入联系电话', trigger:['change', ' blur','input']},
								  { required: true, pattern: /^((\d+-\d+?)|(\d+))$/, message: '请输入正确的电话号码', trigger: 'blur' }
								]" class="h-elformWrap-2" prop="firsttelephone">
                <div class="block">
                  <el-input v-model="order.firsttelephone" placeholder="请输入"></el-input>
                </div>
              </el-form-item>
              <el-form-item label="期望收货日期" class="h-elformWrap-2" width="100%" :rules="[
								  { required: true, message: '请先选择收货地址', trigger: 'blur'},
								]" prop="receivedTime">
                <div class="block">
                  <el-date-picker v-model="order.receivedTime" type="date" :clearable="false" value-format="yyyy-MM-dd" placeholder="--请先选择期望收货日期--">
                  </el-date-picker>
                </div>
              </el-form-item>

              <el-form-item prop="currencyCode" label="币种" :rules="[
								  { required: true, message: '请输入币种', trigger: 'change'},
								]" class="h-elformWrap-2">
                <mdmselect clearable category="YLCurrency" :showcode="true" disabled :v="order.currencyCode" v-model="order.currencyCode"></mdmselect>
              </el-form-item>

              <el-form-item prop="kucun" label="库位" v-if="this.order.orderCategory1 == '4'" class="h-elformWrap-2">
                <brselect clearable category="order_shouh_kuwei" :v="order.kucun" v-model="order.kucun"></brselect>
              </el-form-item>

              <el-form-item prop="kucun" label="库位" :rules="[{ required: true, message: '请选择库位', trigger:['change', 'blur']},]" v-if="this.order.orderCategory1 == '6'" class="h-elformWrap-2">
                <brselect clearable category="nx_mianfei_kuwei" :v="order.kucun" v-model="order.kucun"></brselect>
              </el-form-item>

              <!-- 附件上传 -->
              <el-form-item v-if="(this.order.category1Name == '标准订单'|| this.order.category1Name == '特价订单') && this.lkFlag" label="方案图纸" class="h-elformWrap-2" :rules="[
							  { required: true, message: '请上传方案图纸', trigger: 'change'},
							]">
                <brupload v-model="order.fileUrl" :refid=testID reftype="施工图纸" :limit="1" :showtime="false" uploadflag delflag @filecallback=isUpload>
                </brupload>
              </el-form-item>
              <el-form-item v-if="(this.order.category1Name == '标准订单'|| this.order.category1Name == '特价订单') && this.lkFlag" label="施工确认单" class="h-elformWrap-2" :rules="[
							  { required: true, message: '请上传施工确认单', trigger: 'change'},
							]">
                <brupload v-model="order.sgFileUrl" :refid=testID reftype="NX_SGQRD" :limit="1" :showtime="false" uploadflag delflag @filecallback=sgIsUpload>
                </brupload>
              </el-form-item>

              <el-form-item label="海尔标准配置" prop="isStandard" class="h-elformWrap-2" v-if="(this.order.category1Name == '标准订单'|| this.order.category1Name == '特价订单') && this.lkFlag" :rules="[{ required: true, message: '请选择海尔标准配置', trigger:['change', 'blur']},]">
                <brselect clearable category="haier_standard" :v="order.isStandard" @change="isStandardChange" v-model="order.isStandard"></brselect>
              </el-form-item>

              <el-form-item v-if="(this.order.category1Name == '标准订单'|| this.order.category1Name == '特价订单') && this.lkFlag" label="投标参数" class="h-elformWrap-2" :rules="[
							  { required: true, message: '请上传投标参数', trigger: 'change'},
							]">
                <brupload v-model="order.csFileUrl" :refid=testID reftype="NX_TBCS" :limit="1" :showtime="false" uploadflag delflag @filecallback=csIsUpload>
                </brupload>
              </el-form-item>

              <el-form-item label="是否战略" class="h-elformWrap-2" v-if="(this.order.orderCategory1 == '1' || this.order.orderCategory1 == '2' || this.order.orderCategory1 == '11' ) && agentLevel!=2">
                <brselect clearable category="is_zhanlue" :v="order.isZl" v-model="order.isZl"></brselect>
              </el-form-item>

              <el-form-item label="是否协同收入" class="h-elformWrap-2" v-if="!showXietong" required >
                <brselect clearable category="is_xietong" :v="order.isXietong" v-model="order.isXietong"></brselect>
              </el-form-item>

              <el-form-item v-if="(this.order.orderCategory1 == '1' || this.order.orderCategory1 == '2' || this.order.orderCategory1 == '11')&& agentLevel!=2" label="战略附件" class="h-elformWrap-2">
                <brupload v-model="order.sgFileUrl" :refid=testID reftype="NX_ZLXY" :limit="1" :showtime="false" uploadflag delflag @filecallback=sgIsUpload>
                </brupload>
              </el-form-item>

              <el-form-item v-if="(this.order.orderCategory1 == '2' || this.order.orderCategory1 == '11')" label="管控附件" class="h-elformWrap-2">
                <brupload :refid=testID reftype="管控附件" :limit="1" :showtime="false" uploadflag delflag @filecallback=sgIsUpload>
                </brupload>
              </el-form-item>

              <el-form-item v-if="this.order.orderCategory1 == '6'" label="附件" class="h-elformWrap-2" required>
                <brupload v-model="order.mfFileUrl" :refid=testID reftype="NX_MFFJ" :limit="1" :showtime="false" uploadflag delflag @filecallback=mfIsUpload>
                </brupload>
              </el-form-item>

              <el-form-item v-if="this.zhidanflag&!guanliren" label="直单附件" class="h-elformWrap-2" required>
                <el-upload style="margin-top: 0;" v-model="order.zmFile" class="upload-demo" action="" :http-request="httpRequest2" :on-remove="handleRemove2" :before-remove="beforeRemove" :before-upload="beforeUpload" multiple :file-list="fileList2" :auto-upload=true>
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>

              <!--                            <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;" v-if="(this.order.orderCategory1 == '1' || this.order.orderCategory1 == '2' || this.order.orderCategory1 == '11')">订单为异地发货时，必须选择是否战略以及上传战略附件！！</h6>
                            <el-form-item prop="funnelCode" label="漏斗编号" :rules="[
								  { required: true, message: '请输入漏斗编号', trigger:['change', ' blur','input']},
								]" class="h-elformWrap-2" v-if="this.order.orderCategory1 == '1' || this.order.orderCategory1 == '2' || this.order.orderCategory1 == '11' || this.order.orderCategory1 == '12'">
                                <el-select v-model="order.funnelCode" clearable placeholder="请选择" @change="cleanFunnel()" style="width:100%">
                                    <el-option v-for="item in funnelList"
                                               :key="item.funnelCode"
                                               :label="item.funnelCode"
                                               :value="item.funnelCode">
                                    </el-option>
                                </el-select>
                            </el-form-item>-->

              <h6 style="color: red;font-size: 0.14rem;margin-top: 0.1rem;" v-if="(this.order.orderCategory1 == '1' || this.order.orderCategory1 == '2' || this.order.orderCategory1 == '11')">
                订单为异地发货时，必须选择是否战略以及上传附件！！</h6>

            </el-form>
          </div>
        </div>
      </div>
      <!-------------------------------------------------------客户信息-------------------------------------------------------------------->
      <!--------------------------------售后信息--------------->
      <div class="h-pieceIn2" v-if="showshouhouflag">
        <div class="h-pieceTitle2" style="margin-left:10px;">
          <h1>售后信息</h1>
        </div>
        <div class="h-pieceCon2">
          <div class="h-formLine n-two">
            <el-form :model="order" ref="form2" label-position="right" :inline="true" class="demo-ruleForm h-formbLine">
              <!--<el-form-item prop="tuihyy" label="退货原因" :rules="[-->
              <!--{ required: true, message: '请输入退货原因', trigger: 'change'},-->
              <!--]"  class="h-elformWrap-2">-->
              <!--<brselect clearable category="tuihuo_yuanyin" :v="order.tuihyy"-->
              <!--v-model="order.tuihyy"></brselect>-->
              <!--</el-form-item>-->
              <!--
                            <el-form-item prop="tuihyydes" label="质量检测描述" :rules="[
								  { required: true, message: '请输入质量检测描述', trigger: 'blur'},
								]" class="h-elformWrap-2">
                                <el-input v-model="order.tuihyydes" placeholder="质量检测描述"></el-input>
                            </el-form-item>
                            -->
              <el-form-item prop="tuihyydes" label="质量检测描述" class="h-elformWrap-2">
                <el-input v-model="order.tuihyydes" placeholder="默认检测" style="width: 13rem;"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>

      <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
      <div class="h-table h-mrt30 ljjtablepaddings2" style="margin: 10px 20px 0 10px;">

        <div class="h-pieceTitle2 message" style="margin-bottom: 0.3rem;" v-if="this.order.category1Name == '标准订单'|| this.order.category1Name == '特价订单' || this.order.category1Name == '工程订单'">
          <h1 class="h1">产品信息</h1>
          <!--<el-button size="small" type="primary"-->
          <!--           icon="el-icon-circle-plus"-->
          <!--           style="margin-left: 50px;"-->
          <!--           @click="showLd" v-if="showaddProductRow">选择漏斗-->
          <!--</el-button>-->
        </div>

        <div class="h-pieceTitle2 message" style="margin-bottom: 0.3rem;" v-if="!(this.order.category1Name == '标准订单'|| this.order.category1Name == '特价订单' || this.order.category1Name == '工程订单')">
          <h1 class="h1">产品信息</h1>
          <el-button size="small" type="primary" icon="el-icon-circle-plus" style="margin-left: 50px;" @click="showProcuct1" v-if="showaddProductRow">选择产品
          </el-button>
        </div>

        <div v-for="(obj,index) in companyInfoList" :key="index">
          <div v-if="getProductlist(obj.code).length>0" style="margin-bottom: 20px;">
            <span style="color: #4a4a4a" v-if="!chooseGscode">{{ obj.name }}</span>
            <el-select v-model="zhidanGsCode" placeholder="请选择" @change="chooseGsCode($event),$forceUpdate()" style="width:320px" v-if="chooseGscode">
              <el-option v-for="item in zhidanCompanycode" :key="item.key" :label="item.value" :value="item.key">
              </el-option>
            </el-select>
            <el-form label-position="right" :inline="true" :ref="'form'+obj.code" :model="order" class="demo-ruleForm h-formbLine" style="width: 100%;margin-top: 20px;">
              <el-form-item label="成本中心" :prop="'costCenter'+obj.code" v-if="showIsFree&&!showIsFreeSh" style="width: 50%;" :rules="[
					  { required: true, message: '请选择成本中心', trigger: 'change'},
					]">
                <el-select v-model="order['costCenter'+obj.code]" style="width: 350px;" clearable filterable placeholder="--选择--">
                  <el-option v-for="item in getCostList(obj.code)" :key="item.index" :label="`${item.costCenterCode} : ${item.remark}`" :value="item.costCenterCode"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <el-table ref="multipleTable" :data="getProductlist(obj.code)" stripe border style="width: 100%">
              <el-table-column type="index" label="#" width="40">
              </el-table-column>
              <el-table-column prop="billingStarttime" label="开票开始日期" :show-overflow-tooltip="true" v-if="showJzx" width="150">
                <template slot-scope="scope">
                  <div class="block">
                    <el-date-picker v-model="scope.row.billingStarttime" type="date" :clearable="false" value-format="yyyy-MM-dd" placeholder="--请先选择期望开票日期--">
                    </el-date-picker>
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="billingEndtime" label="开票结束日期" :show-overflow-tooltip="true" v-if="showJzx" width="150">
                <template slot-scope="scope">
                  <div class="block">
                    <el-date-picker v-model="scope.row.billingEndtime" type="date" :clearable="false" value-format="yyyy-MM-dd" placeholder="--请先选择期望开票日期--">
                    </el-date-picker>
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="proModelName" label="产品大类" :show-overflow-tooltip="true" width="100">
              </el-table-column>
              <el-table-column min-width="150" prop="shareModelCode" v-if="!secondAgent" :show-overflow-tooltip="true" label="共享大类">
                <template slot-scope="scope">

                  <el-select class="h-tableInput" v-if="scope.row.proType=='OEM'&&scope.row.smList.length>0" v-model="scope.row.shareModelCode" @change="changeShareModel($event,scope.row)" placeholder="请选择" clearable>
                    <el-option v-for="item in scope.row.smList" :key="item.shareModelCode" :label="item.shareModelName" :value="item.shareModelCode">
                    </el-option>
                  </el-select>
                  <el-select class="h-tableInput" v-if="scope.row.proType!='OEM'||scope.row.smList.length==0" v-model="scope.row.shareModelCode" @change="changeShareModel($event,scope.row)" disabled placeholder="请选择" clearable>

                  </el-select>
                  <!--<brselect :v="scope.row.shareModelCode"  v-if="scope.row.proType=='OEM'" style="width:1.5rem" category="product_level" v-model="scope.row.shareModelCode" @change="changeShareModel($event,scope.row)"
                                            clearable placeholder="&#45;&#45;请选择&#45;&#45;"></brselect>-->

                </template>
              </el-table-column>
              <el-table-column prop="materialCode" label="产品编码" :show-overflow-tooltip="true" width="120">
              </el-table-column>
              <el-table-column min-width="150" prop="materialName" :show-overflow-tooltip="true" label="产品名称">
                <template slot-scope="scope">
                  <div style="text-align: left;">
                    {{ scope.row.materialName }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column min-width="150" prop="oemDesc" :show-overflow-tooltip="true" label="规格型号">
                <template slot-scope="scope">
                  <div style="text-align: left;">
                    {{scope.row.oemDesc}}
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="num" label="漏斗数量" v-if="order.category1Name == '标准订单'|| order.category1Name == '特价订单' || order.category1Name == '工程订单'" width="100">
                <template slot-scope="scope">
                  <div style="text-align: right;">
                    {{ scope.row.num }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="useNum" label="累计下单数量" v-if="order.category1Name == '标准订单'|| order.category1Name == '特价订单' || order.category1Name == '工程订单'" width="130">
                <template slot-scope="scope">
                  <div style="text-align: right;">
                    {{ scope.row.useNum }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="proNumber" label="订单数量" v-if="order.category1Name == '标准订单'|| order.category1Name == '特价订单' || order.category1Name == '工程订单'" width="100">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.proNumber" placeholder="请输入" class="DshuR h-tableInput" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" auto-complete="off"></el-input>
                </template>
              </el-table-column>

              <el-table-column prop="proNumber" label="订单数量" v-if="!(order.category1Name == '标准订单'|| order.category1Name == '特价订单' || order.category1Name == '工程订单')" width="100">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.proNumber" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" placeholder="请输入" v-bind:readonly="showJzx" class="DshuR h-tableInput" auto-complete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="cwddh" label="财务订单号" v-if="showRent" min-width="140">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.cwddh" placeholder="请输入" class="DshuR h-tableInput" auto-complete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="currencyCode" label="币种" :show-overflow-tooltip="true" v-if="!secondAgent && showJzx" width="90">
                <template slot-scope="scope">
                  <div style="text-align: right;">
                    {{ scope.row.currencyCode }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="priceType" label="费用名称" v-if="showJzx" width="150" :show-overflow-tooltip="true">
                <template scope="scope">
                  <brselect clearable category="price_type" :v="scope.row.priceType" @change="getRentPrice(scope.row.priceType,scope.$index)" v-model="scope.row.priceType"></brselect>
                </template>
              </el-table-column>
              <el-table-column prop="proBenchmarkPrice" :label="priceName" :show-overflow-tooltip="true" v-if="!secondAgent" width="90">
                <template slot-scope="scope">
                  <div style="text-align: right;">
                    {{ scope.row.proBenchmarkPrice }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="cgmll" label="毛利率" :show-overflow-tooltip="true" v-if="showShcgmll" width="90">
                <template slot-scope="scope">
                  {{ scope.row.cgmll | numFilter }}
                </template>
              </el-table-column>
              <el-table-column v-if="showSamplePro" prop="discount" label="打折级别" width="90">
                <template slot-scope="scope">
                  <brselect class="h-tableInput" category="sample_product_discount" :v="scope.row.discount" v-if="!isA33" v-model="scope.row.discount" />
                  <brselect class="h-tableInput" category="sample_product_discount_a33" :v="scope.row.discount" v-if="isA33" v-model="scope.row.discount" />
                </template>
              </el-table-column>
              <el-table-column v-if="tejieshowflag" prop="specialPrice" label="特价" width="120">
                <template slot-scope="scope">
                  <el-select class="h-tableInput" v-model="scope.row.specialOfferCode" @change="changeTejia($event,scope.row)" placeholder="请选择" clearable>
                    <el-option v-for="item in scope.row.tjlist" :key="item.tjdtid" :label="item.tejia" :value="item.tjdtid">
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column v-if="tejieshowflag" prop="tjid" label="特价版本号" :show-overflow-tooltip="true" width="160">
              </el-table-column>
              <el-table-column v-if="tejieshowflag" prop="specialPriceNum" label="特价余量" :show-overflow-tooltip="true" width="90">
                <template slot-scope="scope">
                  <div style="text-align: right;">
                    {{ scope.row.specialPriceNum }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column v-if="dingzhishowflag" prop="extraDes" label="定制需求" width="150">
                <template scope="scope">
                  <el-select class="h-tableInput" v-model="scope.row.extraDes" style="width:1.5rem;" allow-create filterable default-first-option @change="changeDingzhi(scope.row)" clearable>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column v-if="dingzhishowflag" prop="extraPrice" label="定制加价" width="120">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.extraPrice" placeholder="请输入" class="DshuR h-tableInput" auto-complete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column v-if="showshouhouflag && !secondAgent" prop="finalPrice" label="成交价" width="100">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.finalPrice" placeholder="请输入" class="DshuR h-tableInput" auto-complete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column v-if="!showshouhouflag && !secondAgent" prop="finalPrice" label="成交价" :show-overflow-tooltip="true" width="100">
                <template slot-scope="scope">
                  <div style="text-align: right;">{{
                      scope.row.finalPrice = new big(scope.row.specialPrice || scope.row.expoPrice ||
                          scope.row.proBenchmarkPrice * scope.row.discount ||
                          scope.row.proBenchmarkPrice).plus(scope.row.extraPrice || 0).toFixed(2).toString()
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="jinejjz" label="净价值" v-if="!secondAgent" width="90">
                <template slot-scope="scope">
                  <div style="text-align: right;">{{
                      scope.row.jinejjz = new
                      big(scope.row.finalPrice).div(scope.row.taxRate).toFixed(2).toString()
                    }}
                  </div>
                </template>
              </el-table-column>

              <el-table-column prop="totalprice" label="总价" v-if="!secondAgent" width="100">
                <template slot-scope="scope">
                  <div style="text-align: right;">{{
                      scope.row.totalprice = new big(scope.row.proNumber ||
                          0).times((scope.row.finalPrice || 0)).toFixed(2).toString()
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column prop="note1" label="备注" min-width="160">
                <template slot-scope="scope">
                  <el-input class="h-tableInput" v-model="scope.row.note1" placeholder="请输入" auto-complete="off"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="操作" v-if="showdelProductRow" width="100" fixed="right">
                <template slot-scope="scope">
                  <el-button type="text" size="small" class="h-tableLink h-btn" @click="deleteThis(scope.row)">
                    删除
                  </el-button>
                  <!-- <div class="l-operationBox">
                                      <span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis(scope.row)"></span>
                                  </div> -->
                </template>
              </el-table-column>
            </el-table>
            <div class="jieguo w-newIcon" v-if="!showIsFree" v-show="!secondAgent">
              <span class="jieguo_label">订单总价</span>
              <span class="jieguo_value">{{ getOrderName(obj.code).orderPrice }}</span>
              <span v-if="!secondAgent" class="jieguo_label">现金余额</span>
              <span v-if="!secondAgent" class="jieguo_value">{{ getOrderName(obj.code).xianjye }}</span>
              <span v-if="!secondAgent" class="jieguo_label">现金占用</span>
              <span v-if="!secondAgent" class="jieguo_value">{{
                  getOrderName(obj.code).orderPriceXj = new big(getOrderName(obj.code).orderPrice || 0).minus(getOrderName(obj.code).orderPriceXd || 0).toString()
                }}</span>
              <span v-if="!secondAgent" class="jieguo_label">现金欠款</span>
              <span v-if="!secondAgent" class="jieguo_value">{{
                  getOrderName(obj.code).orderPriceXjQk = ((new big(getOrderName(obj.code).xianjye || 0).minus(getOrderName(obj.code).orderPriceXj || 0)) > 0 ? 0 : (new big(getOrderName(obj.code).xianjye || 0).minus(getOrderName(obj.code).orderPriceXj || 0).toString()))
                }}</span>
              <span v-if="!secondAgent" class="jieguo_label">信贷选择</span>
              <span v-if="!secondAgent" class="jieguo_value">
                <el-select class="ljjsales" v-model="getOrderName(obj.code).creditid" clearable placeholder="请选择" @change="creditChange($event,obj.code)">
                  <el-option v-for="item in getOrderName(obj.code).creditData" :key="item.id" :label="item.id!=null ? `信贷总额：${ item.quota }`:`请选择` " :value="item.id">
                    <div style="color: #8492a6; font-size: 12px" v-if="item.id!=null">
                      <i style="float: left">信贷总额：{{ item.quota }}</i>&nbsp;
                      <i style="float: right;">信贷截止日期：{{ item.validitydate }}</i>
                    </div>
                  </el-option>
                </el-select>
              </span>
              <span v-if="!secondAgent" class="jieguo_label">信贷占用</span>
              <span v-if="!secondAgent" class="jieguo_value">{{ getOrderName(obj.code).orderPriceXd }}</span>
              <span class="jieguo_label">净价值</span>
              <span class="jieguo_value">{{ getOrderName(obj.code).orderNetWorth }}</span>
            </div>

          </div>
        </div>

      </div>
      <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
      <div v-if="showshouhouflag && productlist2.length>0">
        <div class="h-table h-mrt30 ljjtablepaddings2" style="margin: 20px 20px 0 10px;">
          <div class="h-pieceTitle2 message" style="margin-bottom: 0.3rem;">
            <h1 class="h1">退货产品信息</h1>
            <el-button size="small" type="primary" icon="el-icon-circle-plus" style="margin-left: 50px;" @click="showProcuct2">选择退回产品
            </el-button>
          </div>
          <el-table ref="multipleTable" :data="productlist2" stripe border style="width: 100%">
            <el-table-column fixed type="index" label="#" width="40">
            </el-table-column>
            <el-table-column prop="proModelName" label="产品大类" :show-overflow-tooltip="true" width="100">
            </el-table-column>

            <el-table-column min-width="150" prop="shareModelCode" v-if="!secondAgent" :show-overflow-tooltip="true" label="共享大类">
              <template slot-scope="scope">
                <el-select class="h-tableInput" v-if="scope.row.proType=='OEM'&&scope.row.smList.length>0" v-model="scope.row.shareModelCode" @change="changeShareModel($event,scope.row)" placeholder="请选择" clearable>
                  <el-option v-for="item in scope.row.smList" :key="item.shareModelCode" :label="item.shareModelName" :value="item.shareModelCode">
                  </el-option>
                </el-select>
                <el-select class="h-tableInput" v-if="scope.row.proType!='OEM'||scope.row.smList.length==0" v-model="scope.row.shareModelCode" @change="changeShareModel($event,scope.row)" disabled placeholder="请选择" clearable>

                </el-select>
                <!--<brselect :v="scope.row.shareModelCode" v-if="scope.row.proType=='OEM'" style="width:1.5rem" category="product_level" v-model="scope.row.shareModelCode" @change="changeShareModel($event,scope.row)"
                                          clearable placeholder="&#45;&#45;请选择&#45;&#45;"></brselect>-->

              </template>
            </el-table-column>
            <el-table-column prop="materialCode" label="产品编码" :show-overflow-tooltip="true" width="120">
            </el-table-column>
            <el-table-column prop="materialName" :show-overflow-tooltip="true" label="产品名称">
              <template slot-scope="scope">
                <div style="text-align: left;">
                  {{ scope.row.materialName }}
                </div>
              </template>
            </el-table-column>

            <el-table-column min-width="150" prop="oemDesc" :show-overflow-tooltip="true" label="规格型号">
              <template slot-scope="scope">
                <div style="text-align: left;">
                  {{scope.row.oemDesc}}
                </div>
              </template>
            </el-table-column>

            <el-table-column prop="num" label="漏斗数量" v-if="this.order.category1Name == '标准订单'|| this.order.category1Name == '特价订单' || this.order.category1Name == '工程订单'" width="100">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{ scope.row.num }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="useNum" label="累计下单数量" v-if="this.order.category1Name == '标准订单'|| this.order.category1Name == '特价订单' || this.order.category1Name == '工程订单'" width="130">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{ scope.row.useNum }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="proNumber" label="订单数量" v-if="this.order.category1Name == '标准订单'|| this.order.category1Name == '特价订单' || this.order.category1Name == '工程订单'" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.proNumber" placeholder="请输入" class="DshuR h-tableInput" auto-complete="off"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="proNumber" label="订单数量" v-if="!(this.order.category1Name == '标准订单'|| this.order.category1Name == '特价订单' || this.order.category1Name == '工程订单')" width="100">
              <template slot-scope="scope">
                <el-input v-model="scope.row.proNumber" placeholder="请输入" class="DshuR h-tableInput" auto-complete="off"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="proBenchmarkPrice" label="基准价" :show-overflow-tooltip="true" width="90">
              <template slot-scope="scope">
                <div style="text-align: right;">
                  {{ scope.row.proBenchmarkPrice }}
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="currencyCode" label="币种" v-if="!secondAgent && showJzx" :show-overflow-tooltip="true" width="90">
            </el-table-column>
            <el-table-column prop="priceType" label="费用名称" v-if="showJzx" width="150" :show-overflow-tooltip="true">
              <template scope="scope">
                <brselect clearable category="price_type" :v="scope.row.priceType" @change="getRentPrice(scope.row.priceType,scope.$index)" v-model="scope.row.priceType"></brselect>
              </template>
            </el-table-column>
            <el-table-column prop="finalPrice" label="成交价" width="100">
              <template slot-scope="scope">
                <el-input v-model.number="scope.row.finalPrice" placeholder="请输入" class="DshuR h-tableInput" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" auto-complete="off"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="totalprice" label="总价" :show-overflow-tooltip="true" width="90">
              <template slot-scope="scope">
                <div style="text-align: right;">{{
                    (scope.row.totalprice = new big(scope.row.proNumber || 0).times((scope.row.finalPrice
                        || scope.row.proBenchmarkPrice || 0)).toFixed(2).toString())
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="100" fixed="right">
              <template slot-scope="scope">
                <el-button type="text" size="small" class="h-tableLink h-btn" v-model="scope.row.id" @click="deleteThis2(scope.row)">
                  删除
                </el-button>
                <!-- <div class="l-operationBox">
                                    <span class="l-operationlist br-operation-delete" title="删除" @click="deleteThis2(scope.row)"></span>
                                </div> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <!--------------------------------------------------------------------收货地址弹出框-------------------------------------------------------->
      <!--物料-->
      <wxwl :visible.sync="showwuliaodialog1" v-if="showwuliaodialog1" @choseObj="choseWuliao1" :usercode="order.soldToCode" :ddlx="ddlx" :xmcode="xmcode" :currencyCode="order.currencyCode" :customerChannelCode="order.customerChannelCode" :areaCode="order.salesregion" title="选择物料" />
      <!--售后订单物料-->
      <wxwl :visible.sync="showwuliaodialog2" v-if="showwuliaodialog2" @choseObj="choseWuliao2" :usercode="order.soldToCode" :ddlx="ddlx" :xmcode="xmcode" :currencyCode="order.currencyCode" :customerChannelCode="order.customerChannelCode" :areaCode="order.salesregion" title="选择物料" />
      <!--售达方-->
      <shoudf :visible.sync="showshdfdialog" v-if="showshdfdialog" @choseObj="choseshoudf" oneflag :usercode="currentUser" :xmcode="xmcode" :ddlx="ddlx" :xszz="order.saleGroupCode" title="选择售达方" />
      <!--地址信息-->
      <areaSelect :visible.sync="showdizhiflag" v-if="showdizhiflag" @choseObj="choseDizhi" />
      <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid" />
    </div>
    <div v-if="taskstatus=='0'">
      <div class="anniu" v-if="!resubmit">
        <el-row>
          <el-button class="h-btn h-bBtn h-bgwhite" @click="backtolist">返回</el-button>
          <el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(10)">暂存</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveOrSubmit(20)">确认提交</el-button>
        </el-row>
      </div>
      <div class="anniu" v-else>
        <el-row>
          <el-button class="h-btn h-bBtn h-bgwhite" @click="backtolist">返回</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="resaveOrSubmit(20)">重新提交</el-button>
          <el-button class="h-btn h-bBtn" @click="viewpress">审批跟踪</el-button>
        </el-row>
      </div>
    </div>
    <div class="anniu" v-if="taskstatus == '1'">
      <el-row>
        <el-button class="h-btn h-bBtn h-bgblueQ2" @click="this.$store.dispatch('backToTaskIndex')">返回</el-button>
      </el-row>
    </div>
    <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="institutionalX" class="h-dialog2">
      <companyName ref="companyName" :titleName="titleDig" :add1="add" :stVal="stVal" @getChildValue="closeCompanyName"></companyName>
    </el-dialog>
    <!--    <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="newDialog" class="h-dialog2">
      <div class="h-dialogImg">
        <div class="h-disTable">
          <div class="h-tableCell">
            <h1>{{ titleDig }}</h1>
          </div>
        </div>
      </div>
      <div class="h-formLines">
        <el-form ref="form" :model="add" :inline="true" class="demo-ruleForm h-formbLine h-dialogForm">
          <el-form-item label="单位名称" class="h-elformWrap-2" label-width="100" prop="deptName"
                        :rules="[{ required: true, message: '请输入单位名称', trigger: 'blur'},]">
            &lt;!&ndash;                        <el-input v-model="add.deptName" style="width: 84%" placeholder="请输入单位名称"></el-input>&ndash;&gt;
            &lt;!&ndash;                      <img :src="mapSrc" @click="mapHandleShow" title="地图选点[快速录入]" style="cursor: pointer;width: 20px; margin-top: -20px;vertical-align:bottom"/>&ndash;&gt;
            <el-select v-model="add.deptName" remote filterable :filter-method="selectDept" clearable placeholder="请输入"
                       allow-create filterable
                       :remote-method="selectDept" @change="changeDeptName($event)">
              <el-option v-for="(item) in deptNameList"
                         :key="item.deptName"
                         :label="item.deptName"
                         :value="item.deptName">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="渠道" class="h-elformWrap-2" label-width="100" prop="deptSourceChannel"
                        :rules="[{ required: true, message: '请选择渠道', trigger: 'blur'},]">
            <brselect category="sales_region" :v="add.deptSourceChannel" :showcode="true"
                      v-model="add.deptSourceChannel" clearable></brselect>
          </el-form-item>
          <el-form-item label="省" class="h-elformWrap-2" prop="province"
                        :rules="[{ required: true, message: '必须输入选项', trigger: 'blur'},]">
            <el-select v-model="add.province" @change="handleItemChange1" placeholder="省" style="width: 68%;">
              <el-option
                  v-for="item in shenglist"
                  :key="item.value"
                  :label="item.name"
                  :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="市" class="h-elformWrap-2" prop="city"
                        :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
            <el-select v-model="add.city" @change="handleItemChange2"
                       :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                       placeholder="市" style="width: 68%;">
              <el-option
                  v-for="item in arealist2"
                  :key="item.value"
                  :label="item.name"
                  :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区" class="h-elformWrap-2" prop="area"
                        :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]">
            <el-select v-model="add.area"
                       :rules="[{ required: true, message: '必须输入选项', trigger: 'change'},]"
                       placeholder="区" style="width: 68%;" @change="handleItemChange3">
              <el-option
                  v-for="item in arealist3"
                  :key="item.value"
                  :label="item.name"
                  :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="父级" class="h-elformWrap-1" label-width="100" prop="deptName">
            <treeselect
                :multiple="false"
                :options="options"
                :flat="true"
                :default-expand-level="1"
                placeholder="请选择"
                v-model="stVal"
            />
            <treeselect-value :value="stVal"/>
          </el-form-item>
          <el-form-item label="详细地址" class="h-elformWrap-1"
                        :rules="[
                        { required: true, message: '必须输入选项', trigger: 'blur'},
                        {  max: 30, message: '长度在30个字符以内', trigger: 'blur' }
                    ]"
                        prop="address">
            <el-input v-model="add.address" style="width: 84%;"></el-input>
          </el-form-item>
        </el-form>
        <div style="display:flex;justify-content:center;margin-bottom:20px">
          <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
          <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
        </div>
      </div>
    </el-dialog>-->
    <el-dialog title="选择漏斗" :visible.sync="dialogLd" @close='closeLoudListDialog' width="98%" top="15vh">
      <div class="h-piece">
        <el-form :inline="true" :model="qLd" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item class="h-elformWrap-1" label="经销商">
              <el-input v-model="qLd.agentName" placeholder="输入经销商/编码" disabled="true" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="漏斗编号" class="h-elformWrap-2" prop="username">
              <el-input v-model="qLd.funnelCode" placeholder="输入漏斗编号" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="用户单位" class="h-elformWrap-2" prop="customerName">
              <el-input v-model="qLd.customerName" placeholder="输入用户单位" disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="渠道" prop="chanel">
              <brselect category="sales_region" :v="qLd.customerChannel" v-model="qLd.customerChannel" :clearable="true" disabled="true" style="width:100%" />
            </el-form-item>
          </div>
        </el-form>
        <!-- 展开搜素 -->
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="getLoudList">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="restLd">重置</el-button>
            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="addMx">
              添加到明细
            </el-button>
          </div>
        </div>
      </div>
      <el-table ref="multipleTableLd" :data="dataLd" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChangeLd">
        <el-table-column reserve-selection type="selection" width="35">
        </el-table-column>

        <!--        <el-table-column-->
        <!--            prop="loudProductId"-->
        <!--            label="loudProductId"-->
        <!--            width="140"-->
        <!--            :show-overflow-tooltip="true">-->
        <!--        </el-table-column>-->
        <el-table-column prop="agentName" label="经销商" width="140" :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column prop="funnelCode" label="漏斗编号" width="120">
        </el-table-column>

        <el-table-column prop="customerChannel" label="渠道" width="80">
          <template slot-scope="scope">
            <dictname category="sales_region" :v="scope.row.customerChannel" />
          </template>
        </el-table-column>

        <el-table-column prop="customerName" label="用户单位" width="120">
        </el-table-column>

        <el-table-column prop="xsyb_lianqun" label="链群" width="80">
          <template slot-scope="scope">
            <dictname category="xsyb_lianqun" :v="scope.row.lianqun" />
          </template>
        </el-table-column>
        <el-table-column prop="proModel" label="产品型号" width="120">
        </el-table-column>
        <el-table-column prop="num" label="数量" width="80">
        </el-table-column>

        <el-table-column prop="residueNum" label="剩余数量" width="80">
        </el-table-column>

        <el-table-column prop="price" label="价格" width="80">
        </el-table-column>
        <el-table-column prop="totalPrice" label="金额" width="80">
        </el-table-column>

        <el-table-column prop="proLevelOne" label="产品大类" width="120">
        </el-table-column>

        <el-table-column prop="proLevelTwo" label="产品中类" width="120">
        </el-table-column>

        <!--<el-table-column-->
        <!--        prop="status"-->
        <!--        label="状态">-->
        <!--    <template slot-scope="scope">-->
        <!--        <span v-if="scope.row.status == 0">正常</span>-->
        <!--        <span v-if="scope.row.status == 1">审批中</span>-->
        <!--        <span v-if="scope.row.status == 2">驳回</span>-->
        <!--        <span v-if="scope.row.status == 3">暂存</span>-->
        <!--    </template>-->
        <!--</el-table-column>-->

        <el-table-column prop="salesman" label="销售人员" :show-overflow-tooltip="true" width="100">
        </el-table-column>
        <!--<el-table-column-->
        <!--        prop="partner"-->
        <!--        label="合伙人"-->
        <!--        width="120">-->
        <!--</el-table-column>-->
        <el-table-column prop="statusR" label="节点" width="120">
          <template slot-scope="scope">
            <dictname category="xinxi_jiedian" :v="scope.row.statusR" />
          </template>
        </el-table-column>
        <el-table-column prop="expOnlineDate" label="预计下单日期" width="120">
        </el-table-column>
        <el-table-column prop="expConvDate" label="预计转换日期" width="120">
        </el-table-column>
        <!--
                <el-table-column
                        prop="proType"
                        label="产品类型"
                        width="120">
                </el-table-column>-->
        <el-table-column prop="expectConvertDate" label="报单日期" width="120">
        </el-table-column>
        <el-table-column prop="cuname" label="填单人" width="120">
        </el-table-column>
        <el-table-column prop="areaName" label="区域" width="120">
        </el-table-column>
        <el-table-column prop="province" label="省" width="120">
        </el-table-column>
        <el-table-column prop="city" label="地市" width="120">
        </el-table-column>
        <el-table-column prop="probjectSorts" label="项目分类" width="120">
          <template slot-scope="scope">
            <dictname category="message_type" :v="scope.row.probjectSorts" />
          </template>
        </el-table-column>
        <el-table-column prop="chanceTypeName" label="机会分类" width="120">
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" width="120">
        </el-table-column>
        <el-table-column prop="deptName" label="科室" width="120">
        </el-table-column>
        <el-table-column prop="chargePerson" label="负责人" width="120">
        </el-table-column>
        <el-table-column prop="phone" label="电话" width="120">
        </el-table-column>
        <el-table-column prop="scenesType" label="场景" width="120">
        </el-table-column>
        <!--<el-table-column-->
        <!--    prop="income"-->
        <!--    label="收入"-->
        <!--    width="120">-->
        <!--</el-table-column>-->
        <el-table-column prop="documentaryType" label="跟单商类别" width="120">
          <template slot-scope="scope">
            <dictname category="gendanshang" :v="scope.row.documentaryType" />
          </template>
        </el-table-column>
        <el-table-column prop="agentName" label="对阵签约经销商" :show-overflow-tooltip="true" width="150">
        </el-table-column>
      </el-table>
      <div class="h-pagination2">
        <pagination :page="qLd" @query="getLoudList" />
      </div>
      <div style="margin-top: 20px">
        <!--          <el-button @click="toggleSelection([dataLd[1], dataLd[2]])">切换第二、第三行的选中状态</el-button>-->
        <!--          <el-button @click="toggleSelection()">取消选择</el-button>-->
      </div>
    </el-dialog>
  </div>
</template>
<script>
import big from 'big.js'
import ss from '../../api/SystemService'
import wxwl from '../../components/dialog/wxwl'
import shoudf from '../../components/dialog/selectshdf'
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

import uploadFile from "../../api/process/account_complainUploadService";

import uploaddown from '../../utils/updownfile'

import _ from "loadsh";
import companyName from "@/components/basic/companyName.vue";
export default {
  components: {
    companyName,
    wxwl, shoudf, Treeselect
  },
  filters: {
    gsname: function (v) {
      return _.find(this.allxszz, { code: v }).name;
    },
    numFilter (value) {
      let realVal = ''
      if (value) {
        // 截取当前数据到小数点后两位
        realVal = parseFloat(value).toFixed(2) * 100 + '%'
      } else {
        realVal = '--'
      }
      return realVal
    }
  },
  data () {
    return {
      institutionalX: false,
      orderNu: -1,
      testID: '',
      submitChongfuFlag: true,
      ydgFlag: false,
      priceForShow: "",
      priceName: "基准价",
      contract: "",
      showRent: false,
      showJzx: false,
      showSampleHetong: false,
      contractName: "",
      contractStarttime: "",
      contractEndtime: "",
      checked: true,
      showOrhide: false,
      status: 1,
      toshow: 'createNxOrder2',
      costList9390: [],
      costList9370: [],
      costList1D90: [],
      costList1JC0: [],
      costList1RK0: [],
      costList1R60: [],
      costList9391: [],
      costList0PN0: [],
      costList1S00: [],
      costList1S40: [],
      costList44U0: [],
      costList45K0: [],
      isA33: false,
      showSamplePro: false,
      showIsFree: false,
      showIsFreeSh: false,
      resubmit: false,
      instid: null,
      taskstatus: 0,
      //时候售后订单
      showshouhouflag: false,
      showhistory: false,
      selectDailishang: true,
      showwuliaodialog1: false,
      showwuliaodialog2: false,
      showshdfdialog: false,
      showdizhiflag: false,
      currentUser: null,
      showdelProductRow: true,
      showaddProductRow: true,

      //上海的采购毛利率
      showShcgmll: false,
      //是否可以选择时间
      startDateLimit: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() + 5 * 24 * 3600 * 1000
        }
      },
      openReceivedTimedisabled: true,
      //特价
      tejieshowflag: false,
      //定制展示
      dingzhishowflag: false,
      //现金余额
      cashBalance: 0,
      //展会项目不展示合同号
      contractflag: true,
      xmcode: null,
      //销售组织
      allxszz: [],
      //订单类型
      ddlx: null,
      //是否直单用户
      zhidanflag: 0,
      companycodes: "",
      zhidanCompanycode: [],
      isBlood: 0,
      //经销商级别(一级二级)
      agentLevel: "",
      //是否二级经销商
      secondAgent: false,
      chooseGscode: false,
      zhidanGsCode: "",

      //行项目
      productlist9390: [],
      productlist9370: [],
      productlist1D90: [],
      productlist1JC0: [],
      productlist1RK0: [],
      productlist1R60: [],
      productlist9391: [],
      productlist0PN0: [],
      productlist1S00: [],
      productlist1S40: [],
      productlist44U0: [],
      productlist45K0: [],
      allProductlist: [],
      //客户地址信息
      addrList: [],
      //对象
      order9390: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order9370: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1D90: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1JC0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1RK0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1R60: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order9391: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order0PN0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1S00: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order1S40: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order44U0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      order45K0: {
        orderPrice: 0, // 订单总价
        xianjye: 0,
        taxCat: 0,
        taxRate: 0,
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        creditData: [],
      },
      loudss: [],
      order: {
        id: null, // 主键
        orderMainContract: null, // 主合同编号
        orderSubContract: null, // 分合同编号
        orderProjectCode: null, // 项目编号
        orderProjectName: null, // 项目名称
        projectDescription: null, // 项目描述
        orderCategory: null, // 订单类型
        orderCategory1: null, // 订单详细类型:1-10为内销：1-工程,2-标准,3-改制,4-售后,5-样品机,6-免费,7-展会,8-租赁,9-服务,10-OEM,
        saleGroupCode: null, // 销售组织编码:6200-青岛海尔生物医疗-香港销组织,9390-青岛,9391-上海,9370-青岛海特生物医疗-销售组织 1D90-海乐苗（青岛）智能物联有限公司 1JC0-青岛鸿鹄航空科技有限公司
        disChannelCode: null, // 分销渠道编码:00-通用分销渠道,X1-香港外销渠道,Z1-上海直销渠道
        zCode: null, // 分销渠道编码-子编码
        customerChannelCode: null, // 客户渠道
        isStockUp: null, // 是否备货      1：是；0：否
        orderStatus: null, // 订单状态： 10:暂存  20:审核中, 21:订单管理员通过, 22:订单管理员未通过, 23:财务经理未通过, 24:财务经理通过   30:sap已提交,31:sap待审核,32:sap已通过
        instid: null, // 流程id
        taskId: null, // 流程id
        tuihyy: null, // 退货原因
        tuihyydes: null, // 退货原因说明
        contactName: null, // 联系人名称
        receivedTime: null, // 预计收货时间
        soldToCode: null, // 售达方编码
        soldToName: null, // 售达方名称
        salesregion: null, // 售达方销售区域
        salesregionName: null, // 售达方销售区域名称
        soldToAreaCode: null, // 售达方地区编码
        soldToAreaName: null, // 售达方地区名称
        shipToCode: null, // 送达方编码
        shipToName: null, // 送达方名称
        shipToAreaCode: null, // 送达方地区编码
        invoiceCode: null, // 开票方编码
        payerCode: null, // 付款方编码
        currencyCode: null, // 币种编码
        lpid: '',
        ids: [],
        funnelCode: '',
        orderPrice: 0, // 订单总价
        orderPriceXj: 0, // 订单现金占用
        orderPriceXjQk: 0, // 订单现金欠款
        creditid: null, // 信贷id
        orderPriceXd: 0, // 订单信贷占用
        orderNetWorth: 0, // 订单净价值
        poId: null, // PO号
        areaId: null, // 区域详情表关联id
        dcCode: null, // 配送中心编码
        toProvincesCode: null, // 送达省份编码
        toCityCode: null, // 送达城市编码
        note: null, // 订单备注
        note1: null,//产品备注
        postcode: null, // 邮政编码
        firsttelephone: null, // 第一个电话
        secondtelephone: null, // 第二电话
        extraPrice: null, // 定制加价
        customized: null, // 定制需求
        sapsended: null, // 是否已提交sap,1-是,0-否
        toAddress: null, // 收货地址
        toCompanyname: null, // 送达方公司全称
        posnr: null, // 外销:销售和分销凭证的项目号
        inco1: null, // 外销:国际贸易条款 (部分1)
        inco2: null, // 外销:国际贸易条款 (部分2)
        submitflag: null,//提交标志
        categoryName: null,
        category1Name: null,
        saleGrputName: null,
        disChannelName: null,
        zcodeName: null,
        expoPrice: null,//展会价
        fktj: null, //付款条件
        costCenter9390: null,
        costCenter9370: null,
        costCenter1D90: null,
        costCenter1JC0: null,
        costCenter1RK0: null,
        costCenter1R60: null,
        costCenter9391: null,
        costCenter0PN0: null,
        costCenter1S00: null,
        costCenter1S40: null,
        costCenter44U0: null,
        costCenter45K0: null,
        businessReason: null,

        kucun: null,//库存地点
        lkfileUrl: null,
        fileUrl: [],
        sgFileUrl: null,
        csFileUrl: null,
        isStandard: '',
        isZl: '',
        isXietong: 0,
        mfFileUrl: null,
        loudId: "",
        agentLevel: "",
        zmFile: null,
        upload2: [],
        isChange: 0,
        isCancel: 0,
        returnTime: null,
        zltype: null,
      },
      //产品list
      productlist1: [],
      productlist2: [],
      //客户渠道list
      customerChannelList: [],
      customerChannelListFilter: [],

      lkFlag: false,
      csFlag: false,

      mfUrl: null,

      isedit: "", // 是否是暂存状态的 点击的提交
      newDialog: false,
      titleDig: false,
      shenglist: [],
      arealist2: [],
      arealist3: [],
      add: {
        id: '',
        deptName: '',
        deptType: '',
        leader: '',
        phone: '',
        email: '',
        status: '',
        countryId: '',
        country: '',
        provinceId: '',
        province: '',
        cityId: '',
        city: '',
        areaId: '',
        landmark: '',
        area: '',
        // address: '',
        shengobj: '',
        shiobj: '',
        quobj: '',
        selectId: '',
        address: '',
        subFlag: '',
        deptSourceChannel: '',
        longitude: '',
        latitude: '',
        parentCode: '',
      },
      proSelect: {
        pcode: 0,
        level: 1,
      },
      rules: {
        cwddh: [
          { required: true, message: '请输入财务订单号', trigger: 'blur' },
        ],
        fileUrl: [
          { required: true, message: '请上传方案图纸', trigger: 'blur' }
        ],
        sgFileUrl: [
          { required: true, message: '请上传施工确认单', trigger: 'blur' }
        ],
        csFileUrl: [
          { required: true, message: '请上传投标参数', trigger: 'blur' }
        ]
      },
      deptNameList: [],
      options: [],
      stVal: null,
      reftype2: 'NX_ZMFJ',
      fileList2: [],
      idList: [],
      funnelList: [],//漏斗编号
      dialogLd: false,
      dataLd: [],
      qLd: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
        agentName: '',// 经销商
        agentCode: '',// 经销商编码
        funnelCode: '',//漏斗编码
        customerName: '',// 用户单位
        customerChannel: '',// 渠道
        xmcode: '',  // 项目id
      },// 选择漏斗查询条件
      multipleSelectionLd: [],
      //所用公司信息
      companyInfoList: [],
      guanliren: false,
      showXietong: false,
    }
  },

  //页面加载前事件
  created () {
    // 是否协同收入
    this.showXietong = this.$store.getters.hasRole("swyl_gndailishang,swyl_gwdailishang,swyl_xiaoshoujl,swyl_xiaoshoujl_wx,swyl_dingdgly,swyl_waixiaogly");
    //所用公司信息
    this.companyInfoList = this.$store.getters.dictlist("company_info");
    this.salesregionNameList = this.$store.getters.dictlist("YlSalesArea_chanpin");
    // 当前权限
    this.guanliren = this.$store.getters.hasRole("swyl_xiaoshoujl_yx,yx_shouhoujl");
    //生产所有公司产品变量
    this.companyInfoList.forEach((obj) => {
      this.$set(this.allProductlist, 'productlist' + obj.code, [])
      //动态生成监听
      this.$watch('productlist' + obj.code, (newValue, oldValue) => {

        //计算总金额
        this['order' + obj.code].orderPrice = _.reduce(_.map(newValue, "totalprice"), function (sum, v) {
          return new big(sum).plus(v || 0).toString();
        }, 0)
        //计算总净价值
        this['order' + obj.code].orderNetWorth = _.reduce(_.map(newValue, "jinejjz"), function (sum, v) {
          return new big(sum).plus(v || 0).toString();
        }, 0)
        //重新计算信贷
        if (this['order' + obj.code].creditid) {
          this.creditChange(this['order' + obj.code].creditid, obj.code);
        }
      }, { deep: true, immediate: true });

    })

    if (this.$route.query.id == '' || this.$route.query.id == undefined) {
      this.testID = this.$route.query.ywid
    } else {
      this.testID = this.$route.query.id
    }
    //新生成
    if (this.$route.query.louds != null && this.$route.query.louds != "" && this.$route.query.louds != undefined) {
      console.log("this.$route.query.louds", this.$route.query.louds);
      //订单关联漏斗传过来的 漏斗信息
      this.order.firsttelephone = this.$route.query.louds[0].phone;
      this.order.customerChannelCode = this.$route.query.louds[0].customerChannel;
      this.order.toCompanyname = this.$route.query.louds[0].customerName;
      this.order.lpid = this.$route.query.louds[0].lpid;
      var louds = this.$route.query.louds;
      this.loudss = this.$route.query.louds;
      this.order.ids = louds.map(a => a.lpid);
      this.order.funnelCode = this.$route.query.louds[0].funnelCode;
      this.order.soldToCode = this.$route.query.louds[0].cucode;
      this.order.contactName = this.$route.query.louds[0].chargePerson;
      this.order.toAddress = this.$route.query.louds[0].toAddress;
      this.order.toProvincesName = this.$route.query.louds[0].toProvincesName;
      this.order.toProvincesCode = this.$route.query.louds[0].toProvincesCode;
      this.order.toCityName = this.$route.query.louds[0].toCityName;
      this.order.toCityCode = this.$route.query.louds[0].toCityCode;
      //区域特殊判断
      if (this.$route.query.louds[0].city == '苏州市' || this.$route.query.louds[0].city == '深圳市') {
        this.salesregionName = this.$route.query.louds[0].city;
        ss.OrderMainService.getAreaCode(this.$route.query.louds[0].city).then(rd => {
          this.order.salesregion = rd.msg.code;
          console.log("this.order.salesregion", this.order.salesregion);
        })

      } else {
        //特殊区域判断
        if (this.$route.query.louds[0].province == '西藏自治区') {
          this.salesregionName = '四川省'
          this.order.salesregion = '0025';
        } else if (this.$route.query.louds[0].province == '青海省') {
          this.salesregionName = '甘肃省'
          this.order.salesregion = '0011';
        } else {
          this.salesregionName = this.$route.query.louds[0].province;
          ss.OrderMainService.getAreaCode(this.$route.query.louds[0].province).then(rd => {
            this.order.salesregion = rd.msg.code;
            console.log("this.order.salesregion", this.order.salesregion);
          })
        }
      }
      this.order.areaId = this.$route.query.louds[0].areaId;
    } else {
      // 暂存修改时
      this.order.funnelCode = this.$route.query.funnelCode3;
      this.isedit = "1"
    }
    this.order.fileUrl = []
    this.order.sgFileUrl = []
    this.order.csFileUrl = []
    console.log('我在这儿呀', this.$route.query.chongXinTiJiao);
    this.showzhezhao()
    this.allxszz = this.$store.getters.dictlist('YLSalesOrganization_agent');
    this.customerChannelList = this.$store.getters.dictlist("sales_region");
    let id = this.$route.query.ywid;
    console.log(this.testID)
    let instid = this.$route.query.instid;
    let taskid = this.$route.query.taskid;
    let taskstatus = this.$route.query.taskstatus | 0;
    let chongXinTiJiao = this.$route.query.chongXinTiJiao;
    //代办打开的
    if (id && instid) {
      this.resubmit = true;
      //如果不是重新提交,则不能添加跟删除了
      if (!chongXinTiJiao) {
        this.showaddProductRow = false;
        this.showdelProductRow = false;
      }

      this.instid = instid;
      this.taskstatus = taskstatus;
      this.order.taskId = taskid;
      if (taskstatus == '1') {
        // 直接设置经销商
        this.selectDailishang = false;
        const parent = document.querySelector(".input");
        parent.className = "input el-input ";//改变父集的class,把父集改成可编辑状态，
        //2.在设置input属性
        //获取input
        const input = document.querySelector(".input input");
        //设置input的属性为false
        input.disabled = false;
      }
    }
    if (this.$route.query.agentLevel == 2) {
      this.getSecondOrder(id || this.$route.query.id);
    } else {
      this.getOrder(id || this.$route.query.id);
    }

    // this.order.customerChannelCode = null;
    this.getParentInfo();

    //判断能否显示价格信息
    //如果不是内部用户 并且 agentLevel=2
    if (this._user.usertype != '0' && this._user.agentLevel == 2) {
      //判断是否是分销商（二级经销商）
      this.secondAgent = true;
    }


  },

  computed: {
    xsqyStr () {
      if (this.order.category2Name) {
        return this.order.categoryName + "/" + this.order.category1Name + "/" + this.order.category2Name
      } else if (this.order.category1Name) {
        return this.order.categoryName + "/" + this.order.category1Name
      }
      return this.order.categoryName
    },
  },
  watch: {
    //原逻辑删除mark

  },
  mounted () {

  },
  methods: {

    // 地图选点 弹出
    mapHandleShow () {
      this.mapDialogVisible = true;
      // this.$nextTick(() => {
      //   this.$refs.mapSrcVue.init(id)
      // })
    },
    choseMapShow (objs) {
      console.log("关闭地图11", objs)
      this.add.address = objs.address;
      this.add.deptName = objs.title;
      this.add.province = objs.province;
      this.add.city = objs.city;
      this.add.area = objs.district;
      this.add.longitude = objs.lng;
      this.add.latitude = objs.lat;
      this.loadArea();
      this.mapDialogVisible = false;
    },
    getQueryVariable (variable) {//获取参数id
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return (false);
    },
    isUpload (v) {
      console.log(v)
      if (v.length > 0) {
        //this.order.fileUrl = v[0].saveurl;
        let arrnew = []
        v.forEach(e => {
          arrnew.push(e.saveurl)
        })
        console.log(arrnew)
        this.order.fileUrl = arrnew
        console.log(this.order.fileUrl)
      } else {
        this.order.fileUrl = []
      }
    },
    sgIsUpload (v) {
      console.log('sgIsUpload', v)
      if (v.length > 0) {
        //this.order.fileUrl = v[0].saveurl;
        let arrnew = []
        v.forEach(e => {
          arrnew.push(e.saveurl)
        })
        console.log(arrnew)
        this.order.sgfileUrl = arrnew
        console.log(this.order.sgfileUrl)
      } else {
        this.order.sgfileUrl = []
      }
    },
    csIsUpload (v) {
      console.log('csIsUpload', v)
      if (v.length > 0) {
        //this.order.fileUrl = v[0].saveurl;
        let arrnew = []
        v.forEach(e => {
          arrnew.push(e.saveurl)
        })
        console.log(arrnew)
        this.order.csfileUrl = arrnew
        console.log(this.order.csfileUrl)
      } else {
        this.order.csfileUrl = []
      }
    },
    mfIsUpload (v) {
      console.log('mfIsUpload', v)
      if (v.length > 0) {
        //this.order.fileUrl = v[0].saveurl;
        let arrnew = []
        v.forEach(e => {
          this.order.mffileUrl = e.saveurl
          this.mfUrl = e.saveurl
        })
        // this.order.mffileUrl = arrnew
        console.log(this.order.mffileUrl)
      } else {
        this.order.mffileUrl = null;
      }
    },
    fileBack1 (v) {
      console.log(v)
      this.order.uploadFile = v.length;
    },
    //测试是否包含
    getNumber () {
      console.log(this.order)
      ss.OrderMainService.uploadCheck(this.order).then(res => {
        this.orderNu = res
      })
    },
    testDate () {
      var data = this.order
      console.log(this.order)
      ss.OrderMainService.checkDeliveryDay(data).then(res => {
        console.log(res)
        if (res.f == true) {
          console.log(res)
        } else {
          this.$message.error(res.msg);
        }
      })

    },
    //物流所需时间
    openReceivedTimefocus () {
      if (!this.openReceivedTimedisabled) {
        this.$msg.msge("请先选择的收货地址!");
      }
    },
    showzhezhao () {
      ss.salesList.toshow(this.toshow).then(rd => {
        console.log(rd)
        if (rd == false) {
          this.showOrhide = false;
        } else {
          this.showOrhide = true;
        }
      })
    },
    closeIt () {
      this.showOrhide = false;
      if (this.checked) {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          console.log(rd)
          this.showOrhide = false;
        })
      } else {
        ss.salesList.toshow(this.toshow, this.checked).then(rd => {
          console.log(rd)
          this.showOrhide = false;
        })
      }
    },
    nextcreateNx (i) {
      if (this.status == 1) {

        if (this.checked) {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        } else {
          ss.salesList.toshow(this.toshow, this.checked).then(rd => {
            console.log(rd)
            this.showOrhide = false;
          })
        }
      }
    },
    getSecondOrder (id) {
      ss.SecondOrderMainService.selectSecondOrderById(id).then(rd => {
        _.assign(this.order, rd.obj)
        this.ddlx = this.order.orderCategory + "," + (this.order.orderCategory1 || '');
        this.addMx();
        let type = this.order.orderCategory1;
        // 判断是否是经销商,经销商自己下单
        //当前登录人，就是经销商的话
        if (this._user.usertype == '1') {
          this.order.soldToCode = this._user.usercode;
          this.selectDailishang = false;
        }
        Promise.all([this.getShoudafang(this.order.soldToCode)]).then(() => {
          //存在行项目
          if (rd.obj.products && rd.obj.products.length > 0) {

            rd.obj.products.forEach((obj) => {
              if (obj) {
                this.addProject(obj)
              }
              //判断是否冷库
              ss.waixiao.isLk(obj.materialCode).then(rd => {
                this.lkFlag = rd.msg;
                console.log("lkFlag", this.lkFlag)
              })
            })

          }
          if (rd.obj.isStandard == 2) {
            this.csFlag = true;
          }
        })
      })
    },
    getOrder (id) {
      ss.OrderMainService.selectById(id).then(rd => {
        _.assign(this.order, rd.obj)
        this.ddlx = this.order.orderCategory + "," + (this.order.orderCategory1 || '');
        this.addMx();
        let type = this.order.orderCategory1;
        // 判断是否是经销商,经销商自己下单
        //当前登录人，就是经销商的话
        if (this._user.usertype == '1') {
          this.order.soldToCode = this._user.usercode;
          this.selectDailishang = false;
        }
        Promise.all([this.getShoudafang(this.order.soldToCode)]).then(() => {
          if (type == '1') {
            this.xmcode = this.order.orderProjectCode;
            //项目类型，一定有特价只有特价单，才有特价选择
            this.tejieshowflag = true;
          } else if (type == '7') {
            this.contractflag = false;
            this.xmcode = this.order.orderProjectCode;
          } else if (type == '4') {
            //    售后订单
            this.showshouhouflag = true;
            // 直接设置经销商
            this.selectDailishang = false;
          } else if (type == '3') {
            //    改制订单
            this.dingzhishowflag = true;
          } else if (type == '6' || type == '33') {
            //免费订单
            this.showIsFree = true;
            if (type == '33') {
              this.showIsFreeSh = true;
            }
            this.priceName = "成本价";
            //获取所有成本中心
            this.companyInfoList.forEach((obj) => {
              ss.OrderMainService.getCostCenterList({ companyCode: obj.code }).then(rd => {
                this['costList' + obj.code] = rd;
              })
            });
            //原逻辑删除mark
            //this.order.soldToCode = "A33";
          } else if (type == '5') {
            //样品机订单
            this.showSamplePro = true;
            this.showSampleHetong = true;
          } else if (type == '8') {
            //租赁订单
            this.showRent = true;
            this.xmcode = this.order.orderMainContract;
            ss.contractService.detail(this.order.orderMainContract).then(rd => {
              this.contract = rd.obj;
              this.order.zsyzq = rd.obj.zsyzq;
              if (this.contract.zltype == "3") {
                this.showJzx = true;
              }
              if (this.contract.isShhm == 1) {
                this.contract.isShhm = '1';
              } else if (this.contract.isShhm == 0) {
                this.contract.isShhm = '0';
              }
              if (this.contract.isJj == 1) {
                this.contract.isJj = '1';
              } else if (this.contract.isJj == 0) {
                this.contract.isJj = '0';
              }
              if (this.order.isChange == 1) {
                this.order.isChange = '1';
              } else if (this.order.isChange == 0) {
                this.order.isChange = '0';
              }
              if (this.order.isCancel == 1) {
                this.order.isCancel = '1';
              } else if (this.order.isCancel == 0) {
                this.order.isCancel = '0';
              }
              this.order.rentDate = rd.obj.returnTime;
              this.order.zltype = this.contract.zltype;
              //根据合同编号和订单类型获取代理搜信息
              ss.selectUserAgent.getOneShoudf(this.contract.customerCode).then(rd => {
                this.choseshoudf(rd, true);
              })

            })

          } else if (this.ddlx == '1,11') {
            //只有特价单，才有特价选择
            this.tejieshowflag = true;
          } else if (this.ddlx == '3,32') {
            this.showShcgmll = true;
          }
          //存在行项目
          if (rd.obj.products && rd.obj.products.length > 0) {
            //加载完现金跟信贷，在插入行项目
            Promise.all(this.companyInfoList.map((val, index) => { return this.getCredit(val.code) })).then(() => {
              rd.obj.products.forEach((obj) => {
                if (obj) {
                  if (this.ddlx == '1,4') {
                    //添加行项目
                    if (obj.orderztype == '发货单') {
                      this.addProject(obj)
                    } else if (obj.orderztype == '退货单') {
                      this.productlist2.push(obj);
                    }
                  } else {
                    this.addProject(obj)
                  }
                  //如果是直单经销商，获取附件
                  if (this.zhidanflag == '1') {
                    uploaddown.listdownfile({ refid: obj.id, reftype: "NX_ZMFJ" }).then(rd => {
                      this.fileList2 = rd.obj;
                      this.idList.push(rd.obj.id);
                      this.order.upload2.unshift("1");
                    })
                  }
                }
                //判断是否冷库
                ss.waixiao.isLk(obj.materialCode).then(rd => {
                  this.lkFlag = rd.msg;
                  console.log("lkFlag", this.lkFlag)
                })
              })
              // Promise.all([this.getCredit("9390"), this.getCredit("9370"), this.getCredit("1D90"), this.getCredit("1JC0"), this.getCredit("1RK0"), this.getCredit("9391")]).then(() => {
              //重新计算信贷
              this.companyInfoList.forEach((obj) => {
                if (this['order' + obj.code].creditid) {
                  this.creditChange(this['order' + obj.code].creditid, obj.code);
                }
              })
              //原逻辑删除mark
              //  })
            })
          }
          if (rd.obj.isStandard == 2) {
            this.csFlag = true;
          }
        })
      })
    },
    viewpress (r) {
      this.showhistory = true;
    },
    backtolist () {
      this.$router.go(-1);
    },
    saveOrSubmit (v) {
      this.order.orderStatus = v
      if (v == '10') {
        this.order.submitflag = '暂存'
        this.order.newId = null
      } else if (v == '20') {
        this.order.submitflag = '提交'
        this.order.newId = null
      } else if (v == '30') {
        this.order.orderStatus = 20;
        this.order.newId = this.$route.query.ywid
        this.order.submitflag = '重新提报'
      }
      if (this.order.orderCategory1 == '6') {
        if (this.mfUrl == '' || this.mfUrl == null) {
          if (this.order.mfFileUrl == '' || this.order.mfFileUrl == null) {
            this.$msg.msge("请上传附件！");
            return;
          }
        }
      }
      if (this.zhidanflag == '1' && this.zhidanGsCode != '1R60') {
        if (this.fileList2.length < 1) {
          this.$msg.msge("直单用户下单必须上传直单附件！");
          return;
        }
      }
      // orderPrice:null, // 订单总价
      //     orderPriceXj:0, // 订单现金占用
      //     orderPriceXjQk:0, // 订单现金欠款
      //     creditid:null, // 信贷id
      //     orderPriceXd:0, // 订单信贷占用
      //     orderNetWorth:null, // 订单净价值
      var flag = true;
      //每次提交或者暂存将值清零 防止累加 hyl
      this.order.orderPrice = 0;
      this.order.orderPriceRbm = 0;

      this.companyInfoList.forEach((obj) => {
        _.forEach(this['productlist' + obj.code], (value) => {
          if (this.showRent) {
            if (this.order.businessReason == "" || this.order.businessReason == null) {
              this.$msg.msge("请维护业务原因！");
              flag = false;

            }
            if (value.cwddh == "" || value.cwddh == null) {
              this.$msg.msge("请维护财务订单号！");
              flag = false;

            }
          }

          value.xdid = this['order' + obj.code].creditid
          value.totalpricermb = value.totalprice;
          value.costCenter = this.order['costCenter' + obj.code];

          this.order.orderPrice = new big(this.order.orderPrice || 0).plus(value.totalprice || 0);
          this.order.orderPriceRbm = new big(this.order.orderPriceRbm || 0).plus(value.totalprice || 0);


          //如果是分销商（二级经销商）成交价,净价值,计算总价 hyl
          if (this.secondAgent == true) {
            value.finalPrice = new big(value.specialPrice || value.expoPrice || value.proBenchmarkPrice * value.discount || value.proBenchmarkPrice).plus(value.extraPrice || 0).toFixed(2).toString()
            value.jinejjz = new big(value.finalPrice).div(value.taxRate).toFixed(2).toString()
            value.totalprice = new big(value.proNumber || 0).times((value.finalPrice || 0)).toFixed(2).toString()
          }

          //免费订单，OEM产品库位只能为0099
          if (this.ddlx == '1,6' && value.proType == 'OEM') {
            if (this.order.kucun != '0099') {
              this.$msg.msge("免费订单OEM产品库位必须为0099！");
              flag = false;
            }
          }
        });

      })
      if (this.order.salesregion == '' || this.order.salesregion == null) {
        //根据选中的采购组织编码获取采购组
        ss.OrderMainService.getAreaCode(this.salesregionName).then(rd => {
          this.order.salesregion = rd.msg.code;
          console.log("this.order.salesregion", this.order.salesregion);
        })
        if (this.order.salesregion == '' || this.order.salesregion == null) {
          this.$msg.msge("销售区域为空请联系管理员！");
          flag = false;
        }
      }
      console.log(" this.order.salesregion", this.order.salesregion);
      //原逻辑删除mark


      //计算所有订单现金占用
      this.order.orderPriceXj = this.companyInfoList.reduce((total, item) => {
        return new big(total).plus(new big(this['order' + item.code].orderPriceXj || 0)).toString();
      }, 0)
      //计算所有订单信贷占用
      this.order.orderPriceXd = this.companyInfoList.reduce((total, item) => {
        return new big(total).plus(new big(this['order' + item.code].orderPriceXd || 0)).toString();
      }, 0)
      //计算所有订单净价值
      this.order.orderNetWorth = this.companyInfoList.reduce((total, item) => {
        return new big(total).plus(new big(this['order' + item.code].orderNetWorth || 0)).toString();
      }, 0)
      //原逻辑删除mark
      //this.order.products = [...this.productlist9390, ...this.productlist9370, ...this.productlist1D90,...this.productlist1JC0, ...this.productlist1RK0,...this.productlist9391];
      //合并所有订单list
      this.order.products = [];
      this.companyInfoList.forEach((obj) => {
        this.order.products = this.order.products.concat(this['productlist' + obj.code]);
      })
      this.order.products2 = this.productlist2;

      if (flag) {
        if (this.order.submitflag == '提交' || this.order.submitflag == '重新提报') {
          //免费订单校验
          var freeflag = true;
          var companyFlag = true;
          if (this.showIsFree) {
            this.$refs['form0'].validate((valid0) => {
              freeflag = valid0;
            });
            //校验是否选择成本中心
            this.companyInfoList.forEach((obj) => {
              if (this['productlist' + obj.code].length > 0) {
                this.$refs['form' + obj.code].validate((valid0) => {
                  if (!valid0) {
                    companyFlag = valid0;
                    return false;
                  }
                });
              }
            })
            //原逻辑删除mark
            /* if (this.productlist9390.length > 0) {
                 this.$refs['form9390'].validate((valid0) => {
                     freeflag9390 = valid0;
                 });
             }


            }*/
          }

          this.$refs['form1'].validate((valid1) => {
            if (valid1 && freeflag && companyFlag) {
              this.$msg.confirm("确认提交？", () => {
                var list = [];
                var notallwuliao = false;
                for (let i = 0; i < this.order.products.length; i++) {
                  var num = this.order.products[i].num;
                  var useNum = this.order.products[i].useNum;
                  var proNumber = this.order.products[i].proNumber;
                  if (num < proNumber) {
                    this.$msg.msge("订单数量不能大于漏斗数量！");
                    return;
                  }
                  if (num == useNum + proNumber) {
                    var data = {};
                    if (this.order.products[i].funnelProductId != null && this.order.products[i].funnelProductId != "" && this.order.products[i].funnelProductId != undefined) {
                      data.id = this.order.products[i].funnelProductId
                    } else {
                      data.id = this.order.products[i].lpid;
                    }
                    data.state = "3"
                    data.notallwuliao = false;
                    list.push(data);
                  } else if (num > useNum + proNumber) {
                    var data = {};
                    if (this.order.products[i].funnelProductId != null && this.order.products[i].funnelProductId != "" && this.order.products[i].funnelProductId != undefined) {
                      data.id = this.order.products[i].funnelProductId
                    } else {
                      data.id = this.order.products[i].lpid;
                    }
                    data.state = "3"
                    data.notallwuliao = true;
                    list.push(data);
                    notallwuliao = true;
                  }
                }
                if (notallwuliao) {
                  this.$confirm('漏斗上还有剩余产品数量，下次是否继续下单?', '', {
                    confirmButtonText: '否',
                    cancelButtonText: '是',
                    type: 'warning'
                  }).then(() => {
                    this.submitForm(list);
                  }).catch(() => {
                    for (let i = 0; i < list.length; i++) {
                      console.log("list[i]", list[i])
                      if (list[i].notallwuliao) {
                        list[i].state = "2";
                      }
                    }
                    this.submitForm(list);
                  });
                } else {
                  this.submitForm(list);
                }
              })
            } else {
              this.$msg.msge("请完善基本信息后提交");
              return;
            }
          });
        } else {
          this.submitForm();
        }
      }

    },
    submitForm (data) {
      if (this.submitChongfuFlag) {

        if (this.order.tuihyydes == '' || this.order.tuihyydes == null) {
          this.order.tuihyydes = '检测'
        }
        this.order.ydgFlag = this.ydgFlag;
        console.log(this.order)
        //标准订单和特殊订单
        if (this.order.category1Name == '标准订单' || this.order.category1Name == '特价订单') {
          //检测是否需要上传附件
          ss.OrderMainService.uploadCheck(this.order).then(res => {
            this.orderNu = res
            if (this.orderNu == 1 && this.order.isStandard == 1) {
              this.$message.error('此产品为冷库产品，请上传方案图纸和施工确认单');
              //
            } else if (this.orderNu == 1 && this.order.isStandard == 2) {
              this.$message.error('此产品为冷库产品，请上传方案图纸,施工确认单和投标参数');
            } else {
              ss.OrderMainService.checkDeliveryDay(this.order).then(res => {
                console.log(res)
                if (res.f == true) {
                  console.log(res)
                  this.submitChongfuFlag = false;
                  ss.OrderMainService.saveOrSubmit(this.order).then(rd => {
                    this.submitChongfuFlag = true;
                    if (rd.f) {
                      if (this.order.submitflag == '提交' || this.order.submitflag == '重新提报') {
                        this.$msg.msgs("提交成功！")
                        //修改漏斗状态
                        ss.loudnew.updateprostatus(data).then(res => {
                        })
                        //二级经销商订单条二级经销商页面
                        if (this.agentLevel == 2) {
                          this.$router.push({ path: '/dingd/secondDingdmainlist' })
                        } else {
                          this.$router.push({ path: '/dingd/dingdmainlist' })
                        }

                      } else {
                        this.$msg.msgs("暂存成功！")
                      }
                    } else {
                      this.$msg.msge(rd.msg);
                    }
                  })
                } else {
                  this.$message.error(res.msg);
                }
              })
            }

          })


        } else {
          this.submitChongfuFlag = false;
          // 非标准订单，非特殊订单
          ss.OrderMainService.saveOrSubmit(this.order).then(rd => {
            this.submitChongfuFlag = true;
            if (rd.f) {
              if (this.order.submitflag == '提交' || this.order.submitflag == '重新提报') {
                this.$msg.msgs("提交成功！")
                //二级经销商订单条二级经销商页面
                //修改漏斗状态
                ss.loudnew.updateprostatus(data).then(res => {
                })
                if (this.agentLevel == 2) {
                  this.$router.push({ path: '/dingd/secondDingdmainlist' })
                } else {
                  this.$router.push({ path: '/dingd/dingdmainlist' })
                }

              } else {
                this.$msg.msgs("暂存成功！")
              }
            } else {

              this.$msg.msge(rd.msg);
            }
          })
        }
      } else {
        this.$msg.msge("重复点击提交，请稍后操作！");
      }
    },
    resaveOrSubmit (v) {
      this.saveOrSubmit(30);
      // this.order.orderStatus = v
      // this.$msg.confirm("确认提交？", () => {
      //     this.order.submitflag = '重新提报'
      //     ss.OrderMainService.saveOrSubmit(this.order).then(rd => {
      //         this.$router.push({path: '/dingd/dingdmainlist'})
      //     })
      // })
    },
    getShoudafang (usercode) {
      if (!usercode) {
        return "";
      }
      return ss.selectUserAgent.getOneShoudf(this.order.soldToCode).then(rd => {
        this.choseshoudf(rd, true);
      })
    },
    //查询用户，用户余额，所有信贷
    getCredit (gscode) {
      var params = {};
      // console.log(this['productlist' + gscode])
      // console.log(_.map(this['productlist' + gscode], "proModelCode"))
      //列表中的第一个的产品大类
      var cpdl = _.uniq(_.map(this['productlist' + gscode], "proModelCode"));
      if (cpdl.length == 1) {
        params.cpdlcode = cpdl[0];
      }
      params.salegroupcode = gscode;
      params.usercode = this.order.soldToCode;
      // console.log(params)
      return ss.OrderMainService.getUserMoneyCredit(params).then(rd => {
        console.log("信贷", rd)
        this['order' + gscode].creditData = rd.xd;
        this['order' + gscode].xianjye = rd.xj ? (rd.xj.cashBalance || 0) : 0;
      })
    }
    ,
    // 选择具体的信贷
    creditChange (v, gscode) {
      console.log("默认选中信贷", v, gscode)
      if (v) {
        var orderje = this['order' + gscode].orderPrice;
        var xd = _.find(this['order' + gscode].creditData, { id: v })
        var xdye = xd.quota;
        //用户的现金余额
        var xjye = this['order' + gscode].xianjye;
        if (xjye > 0) {
          if (xjye >= orderje) {
            this['order' + gscode].creditid = null;
            this['order' + gscode].orderPriceXd = 0;
          } else {
            //现金+信贷>订单金额
            if (xdye + xjye > orderje) {
              this['order' + gscode].orderPriceXd = orderje - xjye;
            } else {
              if (orderje - xjye < xdye) {
                this['order' + gscode].orderPriceXd = orderje - xjye;
              } else {
                this['order' + gscode].orderPriceXd = xdye;
              }
            }
          }
        } else {
          //信贷金额，大于订单总额
          if (xdye >= orderje) {
            this['order' + gscode].orderPriceXd = orderje;
          } else {
            //订单减掉现金余额
            this['order' + gscode].orderPriceXd = xdye;
          }
        }
      } else {
        this['order' + gscode].creditid = null;
        this['order' + gscode].orderPriceXd = 0;
      }
    },
    //定制改变
    changeDingzhi (row) {
      if (row.extraDes) {
        row.isCustommed = 1;
      } else {
        row.isCustommed = 0;
        row.extraPrice = null;
        row.extraDes = null;
      }
    },
    //修改共享大类
    changeShareModel (scode, row) {
      console.log(scode);
      if (row.shareModelCode) {
        const smobj = _.find(row.smList, { shareModelCode: row.shareModelCode })
        row.shareModelName = smobj.shareModelName;
        console.log(row.shareModelName);
      } else {
        row.shareModelName = null;
      }
    },
    //特价改变
    changeTejia (scode, row) {
      console.log('特价改变', scode, row)
      if (row.specialOfferCode) {
        const tjobj = _.find(row.tjlist, { tjdtid: row.specialOfferCode })
        row.specialPrice = tjobj.tejia;
        row.specialPriceNum = tjobj.sysl;
        row.tjid = tjobj.tjid;
        row.tjdtid = tjobj.tjdtid;
        /*                    if(this.ddlx == '1,11'){
                                          row.proBenchmarkPrice = tjobj.dingjia;//产品基准价
                                        }*/
        if (this.ddlx == '1,11' || this.ddlx == '1,1') {
          row.proBenchmarkPrice = tjobj.dingjia;//产品基准价
        }
      } else {
        row.specialOfferCode = null;
        row.specialPrice = null;
        row.specialPriceNum = null;
        row.tjid = null;
        row.tjdtid = null;
        /*                    if(this.ddlx == '1,11'){
                                          row.proBenchmarkPrice = 0;//产品基准价
                                        }*/
        if (this.ddlx == '1,11' || this.ddlx == '1,1') {
          row.proBenchmarkPrice = 0;//产品基准价
        }
      }
    },

    //清空已选产品列表
    cleanOrder () {
      console.log('客户渠道发生变化!')
      if (this.ddlx == '1,4') {
        return;
      }
      this.companyInfoList.forEach((obj) => {
        this['productlist' + obj.code] = [];
      })
      this.productlist2 = [];
      if (this.showJzx) {
        //如果租赁合同中只包含一个产品，则直接带出 wxwl
        let proList = {};
        if (this.contract.zlList) {
          var list = this.contract.zlList;
          //根据产品编码去重
          list = list.reduce((total, currentValue) => {
            proList[currentValue.productCode] ? '' : proList[currentValue.productCode] = total.push(currentValue);
            return total
          }, [])
          if (list.length == 1) {
            var data = {};
            var proData = {};
            data.usercode = this.order.soldToCode;
            data.ddlx = this.ddlx;
            data.xmcode = this.order.orderMainContract;
            data.currencyCode = this.order.currencyCode;
            data.customerChannelCode = this.order.customerChannelCode;
            data.wlcodename = list[0].productCode;
            ss.wuliaoselect.selectPage(data).then(rd => {
              proData = rd.records;
              this.choseWuliao1(proData);
            })
          }
        }
      }
    },
    cleanFunnel () {
      this.companyInfoList.forEach((obj) => {
        this['productlist' + obj.code] = [];
      })

      this.productlist2 = [];
      //如果渠道不为空，根据渠道和经销商编码获取漏斗信息
      if (this.order.funnelCode) {
        var data = {};
        data.agentCode = this.order.soldToCode;
        data.customerChannel = this.order.customerChannelCode;
        data.funnelCode = this.order.funnelCode;
        data.areaCode = this.salesregionName;
        data.ddlx = this.ddlx;
        if (this.ddlx == '1,1') {
          data.xmcode = this.order.orderProjectCode;
        }
        ss.OrderMainService.selectNxnewWl(data).then(rd => {
          if (rd.f) {
            this.choseWuliao1(rd.msg);
          }
        })
      }
    },

    //选择售达方
    openShoudf () {
      this.showshdfdialog = true;
    },
    choseshoudf (obj, changeflag) {

      console.log('1234-->', obj)
      //                设置客户渠道，
      //                 this.customerChannelListFilter = _.split(obj.khqd,",");
      //                 if(this.customerChannelListFilter.length>0){
      //                     this.order.customerChannelCode=obj.khqd;
      //                 }else{
      //                     this.showshdfdialog = false
      //                     this.$msg.msge("该售达方没有维护客户渠道信息，请联系管理员！")
      //                     return;
      //                 }

      //直单用户flag
      this.zhidanflag = obj.zhidanflag;
      this.companycodes = obj.companycodeBas;
      this.isBlood = obj.isBlood;
      //是否直单用户根据签约的公司进行选择
      this.zhidanCompanycode = [];
      this.zhidanGsCode = '';
      //设置经销商级别
      this.agentLevel = obj.agentLevel;
      this.order.agentLevel = obj.agentLevel;
      //是否直单用户并且内销标准订单 可选择公司
      console.log("类型", this.ddlx);
      if (this.zhidanflag == '1' && this.ddlx != '1,6') {
        this.chooseGscode = true;
        //判断当前用户可选择的公司
        this.companyInfoList.forEach((obj) => {
          if (this.companycodes.indexOf(obj.code) != -1) {
            this.zhidanCompanycode.push({
              key: obj.code,
              value: obj.name
            });
            this.zhidanGsCode = obj.code
          }
        })

        //0HL0 特殊处理
        if (this.companycodes.indexOf("0HL0") != -1) {
          this.zhidanCompanycode.push({
            key: "9370",
            value: "青岛海尔生物医疗科技有限公司(9370)"
          });
          this.zhidanGsCode = '9370'
        }

        //如果都没签约9370或9390或1D90或1JC0或1RK0 提示错误
        if (this.companycodes.length <= 0) {
          this.showshdfdialog = false
          this.$msg.msge("该直单用户没有签约公司，请联系管理员！")
          return;
        }


        //租赁订单自己选
      } else if (this.ddlx == '1,8') {
        //所有可选的公司
        this.companyInfoList.forEach((obj) => {
          this.zhidanCompanycode.push({
            key: obj.code,
            value: obj.name
          });
        })
        this.zhidanGsCode = '9370'
        this.chooseGscode = true;
      } else {
        this.chooseGscode = false;
      }


      console.log("公司代码：" + this.companycodes);
      console.log("是否血站渠道：" + this.isBlood);
      console.log("订单主数据", this.order);
      // 设置客户渠道，
      //如果是工程订单
      if (this.ddlx == '1,1') {
        this.customerChannelListFilter = _.filter(this.customerChannelList, (o) => {
          return _.split(this.order.khqd4 || '', ",").includes(o.code);
        });
      } else {
        this.customerChannelListFilter = _.filter(this.customerChannelList, (o) => {
          return _.split(obj.khqd3 || '', ",").includes(o.code);
        });
      }
      if (this.customerChannelListFilter.length > 0) {
        //    this.order.customerChannelCode = null;
      } else {
        this.showshdfdialog = false
        this.$msg.msge("该售达方没有维护客户渠道信息，请联系管理员！")
        return;
      }
      if (this.ddlx == '1,6') {
        this.customerChannelListFilter = _.filter(this.customerChannelList, (o) => {
          return _.split(obj.khqd3 || '', ",").includes(o.code);
        });
        this.order.salesregion = obj.salesregion;
        this.order.salesregionName = obj.salesregionName;
      }

      // 清空物料
      if (this.order.soldToCode != obj.usercode) {
        this.companyInfoList.forEach((obj) => {
          this['productlist' + obj.code] = [];
        })
        this.productlist2 = [];
      }
      //如果是A33客户（青岛海尔特种电器有限公司一次性客户） 此字段应于判断样品机订单 A33客户的打折级别
      if (obj.usercode == 'A33') {
        this.isA33 = true;
      } else {
        this.isA33 = false;
      }
      this.order.soldToName = obj.username;
      this.order.soldToCode = obj.usercode;
      this.order.soldToAreaCode = obj.area;
      this.order.soldToAreaName = obj.areaname;
      this.order.gjmytk = obj.gjmytk; //国际贸易条款
      this.order.salesregionName = this.salesregionName;
      this.order.fktj = obj.fktj; //付款条件
      this.order.currencyCode = (changeflag ? this.order.currencyCode : obj.currency) || 'CNY';
      this.showshdfdialog = false;

      // this.order.customerChannelCode = null;

    },
    //
    deleteThis (row) {

      console.log(row, "删除");
      var id = row.id;
      var gscode = row.gscode;
      this.$msg.confirm("确认删除？", () => {
        this['productlist' + gscode] = _.reject(this['productlist' + gscode], { 'id': id });
        //合并所有订单list
        this.order.products = [];
        this.companyInfoList.forEach((obj) => {
          this.order.products = this.order.products.concat(this['productlist' + obj.code]);
        })

        //删除的时候,没有一个了，肯定是false
        this.ydgFlag = this.order.products.length == 0 ? false : this.ydgFlag;
      })


    },
    //删除该行项目产品信息
    deleteThis2 (row) {
      var id = row.id;
      if (this.productlist2.length == 1) {
        this.$msg.msge("至少保留一个退回产品！")
        return;
      }
      this.$msg.confirm("确认删除？", () => {
        this.productlist2 = _.reject(this.productlist2, { 'id': id });
      })
    },


    //选择物料删除该行项目产品信息
    //选择物料
    showProcuct1 () {
      if (!this.order.soldToCode) {
        this.$msg.msge("请先选择售达方信息！")
        return;
      }
      if (this.order.orderCategory1 != 7 && this.order.orderCategory1 != 9 && !this.order.customerChannelCode) {
        this.$msg.msge("请先选择客户渠道！")
        return;
      }
      this.showwuliaodialog1 = true;
    },
    //选择物料
    choseWuliao1 (objs) {
      console.log("选中的物料", objs)
      this.showwuliaodialog1 = false;
      console.log("============================" + objs.length);
      if (objs.length == 0) {
        this.$msg.msge("该产品条件不符合,不允许下单！")
      }
      for (var i = 0; i < objs.length; i++) {
        var addwl = objs[i];
        var wl = this.wlToProject(addwl);
        //售后单,同步添加list2
        if (this.ddlx == '1,4') {
          //添加行项目
          this.addProject(wl);
          var newobj = _.clone(wl);
          newobj.id = this.$util.getUuid();
          this.productlist2.push(newobj);
        } else if (this.ddlx == '1,8') {

          if (this.contract.zlList && this.contract.zltype == '3') {
            if (this['productlist' + wl.gscode].length > 0) {
              for (var i = 0; i < this['productlist' + wl.gscode].length; i++) {
                var contractMa = this['productlist' + wl.gscode][i];
                if (contractMa.materialCode != wl.materialCode) {
                  this.$msg.msge("同一订单只能包含一个产品！");
                  return;
                }
              }
            }
            var zulins = [];
            this.contract.zlList.forEach((obj) => {
              if (obj.productCode == wl.materialCode) {
                zulins.push(obj);
              }
            })
            if (zulins) {
              for (var i = 0; i < zulins[0].rentNum; i++) {
                zulins.forEach((obj) => {
                  var newobj = _.clone(wl);
                  newobj.id = this.$util.getUuid();
                  newobj.priceType = obj.priceType;
                  newobj.proNumber = 1;//产品数量
                  newobj.proBenchmarkPrice = obj.productUnitPrice;//产品基准价
                  newobj.rentSort = i;
                  this.addProject(newobj);
                })
              }
            }
          } else {
            var newobj = _.clone(wl);
            newobj.id = this.$util.getUuid();
            this.addProject(newobj);
          }
        } else {
          //添加行项目
          this.addProject(wl);
          this.changeTejia("1", wl);
        }
        var lkData = wl.materialCode;
        //判断选中的产品是否是冷库产品
        ss.waixiao.isLk(lkData).then(rd => {
          this.lkFlag = rd.msg;
          console.log("lkFlag", this.lkFlag)
          //如果是冷库产品,则在新增时需先生成一个虚拟的预测单号用于绑定附件,点击预测单提交时更新绑定真实的预测单编号
        })
      }
      //加载现金跟信贷
      //获取遍历公司调用getCredit方法
      Promise.all(this.companyInfoList.map((val, index) => { return this.getCredit(val.code) })).then(() => {
        this.companyInfoList.forEach((obj) => {
          this['order' + obj.code].creditid = this['order' + obj.code].creditData.length > 0 ? _.first(this['order' + obj.code].creditData).id : null;
          this['order' + obj.code].orderPriceXd = 0;
        })
        //原逻辑删除mark
      })

    },
    //选择物料
    showProcuct2 () {
      this.showwuliaodialog2 = true;
    },
    choseWuliao2 (objs) {
      console.log("选中的物料", objs)
      for (var i = 0; i < objs.length; i++) {
        var addwl = objs[i];
        var wl = this.wlToProject(addwl);
        this.productlist2.push(wl);
      }
      this.showwuliaodialog2 = false;
    },
    addProject (obj) {
      console.log(obj.id + "行项目");
      var alllist = []
      //合并所有订单list
      this.companyInfoList.forEach((obj) => {
        alllist = alllist.concat(this['productlist' + obj.code]);
      })

      console.log("alllist", alllist)
      // 不是直单的用户，如果下液氮罐的话，必须单独下单
      if (this.zhidanflag != '1' && obj.proModelCode == 'ND1' && (this.ddlx != '1,4' && this.ddlx != '1,6')) {
        // 看看产品列表里有没有其他产品
        for (var i = 0; i < alllist.length; i++) {
          var one = alllist[i];
          if (one.proModelCode != 'ND1') {
            this.$msg.msge("液氮罐系列产品不能跟其他产品一起下单，请单独下单！");
            return;
          }
        }
        // this.ydgFlag = true;
      }
      if (this.zhidanflag != '1' && obj.proModelCode != 'ND1' && (this.ddlx != '1,4' && this.ddlx != '1,6')) {
        // 看看产品列表里有没有其他产品
        for (var i = 0; i < alllist.length; i++) {
          var one = alllist[i];
          if (one.proModelCode == 'ND1') {
            this.$msg.msge("液氮罐系列产品不能跟其他产品一起下单，请单独下单！");
            return;
          }
        }
        this.ydgFlag = false;
      }

      if (!this.order['costCenter' + obj.gscode]) {
        this.order['costCenter' + obj.gscode] = obj.costCenter || null;
      }
      //只有特价单，才有特价选择
      if (this.ddlx == '1,11' || this.ddlx == '1,1') {
        if (obj.tjlist && obj.tjlist.length == 0) {
          this.$msg.msge("申请的特价余量已为0，不允许选择下单！");
          return;
        }
        // 设置特价余量
        const checktejia = _.find(obj.tjlist, { tjdtid: obj.specialOfferCode })
        if (checktejia) {
          obj.specialPriceNum = checktejia.sysl
          obj.tjid = checktejia.tjid;
        }
      }
      //工程订单默认选取特价
      if (this.ddlx == '1,1') {
        obj.specialOfferCode = obj.tjlist[0].tjdtid;
      }

      if (this.ddlx == '1,1' || this.ddlx == '1,2' || this.ddlx == '1,11') {
        if (obj.loudId) {
          this.order.loudId = obj.loudId;
        }
      }

      /*  if (obj.fromtype == 'sh') {
                    obj.gscode = "9391";
                }*/
      //直单用户的话 只能选择签约的公司（9390或9370）
      if (this.zhidanflag == '1' && this.ddlx != '1,6') {
        if (this.zhidanGsCode == '') {
          this.$msg.msge("该直单用户没有签约公司，请联系管理员！");
          return;
        } else {
          //根据用户选择公司编码 hyl
          obj.gscode = this.zhidanGsCode;
        }

      }

      if (this.ddlx == '1,1' || this.ddlx == '1,2' || this.ddlx == '1,11') {
        if (obj.isLast == 1) {
          obj.isLast = '1';
        }
        if (obj.isLast == 0) {
          obj.isLast = '0';
        }
      }

      /*//签约9370公司并且是血站专用渠道，全部下到9370
                if(this.isBlood == '1'){
                    obj.gscode = "9370";
                }

                //售后单，也只有9390
                if (this.ddlx == '1,4') {
                    obj.gscode = "9390";
                }
                //如果是离心机产品，只能下9370
                if (obj.cpdlcode == 'NA7') {
                    obj.gscode = "9370";
                    this.zhidanGsCode = "9370";
                }
*/
      this['productlist' + obj.gscode].push(obj);
      this['order' + obj.gscode].creditid = obj.xdid;
      console.log(obj.gscode)
      console.log("this['productlist' + obj.gscode]", this['productlist' + obj.gscode])
    },
    wlToProject (obj) {
      var wl = {};
      wl.id = this.$util.getUuid();
      wl.materialCode = obj.matecode;//物料编码
      wl.materialName = obj.matedes;//物料名称
      wl.proModelCode = obj.cpdlcode;//产品型号编码
      wl.proModelName = obj.cpdlname;//产品型号名称
      wl.cpz = obj.cpz; //产品组
      wl.dwcode = obj.dwcode;//单位
      wl.dwname = obj.dwname;//单位
      wl.currencyCode = obj.currency;//币种编码
      if (obj.taxCat != null && obj.taxCat != '') {
        wl.taxCat = obj.taxCat;//税分类
      } else {
        this.$msg.msge("税分类不能为空！");
        return;
      }
      wl.field = obj.field;//选择产品所在的领域
      wl.orderField = obj.field;//选择产品所在的领域
      //税率
      if (wl.taxCat == '2' || wl.taxCat == '3' || wl.taxCat == '4') {
        wl.taxRate = 1.13;
      } else if (wl.taxCat == '7') {
        wl.taxRate = 1.06;
      } else {
        wl.taxRate = 1;
      }

      if (this.contract.contractAmount != null) {
        wl.proBenchmarkPrice = this.contract.contractAmount;
        // wl.proNumber = this.contract.rentNum;

        if (this.contract.zlList) {
          if (this.contract.zltype != '3') {
            this.contract.zlList.forEach((obj) => {
              if (wl.materialCode == obj.productCode) {
                wl.proNumber = 1;
                wl.proNumber1 = obj.rentNum;
                wl.proBenchmarkPrice = obj.productUnitPrice;//产品基准价
              }
            })
          }
          if (this.contract.zltype == '3') {
            wl.rentSort = null;
          }
          wl.zltype = this.contract.zltype;
          wl.priceType = null;
        }


      } else if (this.ddlx == '1,6') {
        wl.proNumber = 1;//产品数量
        wl.proBenchmarkPrice = obj.jizhj;//产品基准价
      } else {
        wl.proNumber = 0;//产品数量
        wl.proBenchmarkPrice = obj.jizhj;//产品基准价
      }
      wl.specialOfferCode = null; // 特价版本
      wl.specialPrice = null; // 特价价格
      wl.specialPriceNum = null; // 特价价格
      wl.tjid = null; // 特价id
      wl.tjdtid = null; // 特价蛋疼id
      wl.isCustommed = 0; // 是否定制     1：是   0 否
      wl.extraPrice = null; // 定制加价
      wl.extraDes = null; // 定制需求
      wl.cwddh = null;
      //211220 公司代码根据销售样表来
      if (this.ddlx == '1,1' || this.ddlx == '1,2' || this.ddlx == '1,11') {
        if (obj.companycode == '1D90') {
          //物料销售公司是海乐苗，代理商签约1D90但未签约1RK0,则销售组织是1D90
          if (this.companycodes.indexOf('1D90') != -1 && this.companycodes.indexOf('1RK0') == -1) {
            wl.gscode = '1D90';
          } else if ((this.companycodes.indexOf('1D90') != -1 && this.companycodes.indexOf('1RK0') != -1)
            || (this.companycodes.indexOf('1D90') == -1 && this.companycodes.indexOf('1RK0') != -1)) {
            //物料销售公司是海乐苗，未签约1D90但签约1RK0或1D90和1RK0都签约了，销售公司是1RK0
            wl.gscode = '1RK0';
          } else {
            wl.gscode = obj.companycode; //公司编码
          }

        } else {
          wl.gscode = obj.companycode; //公司编码
        }
      } else {
        wl.gscode = obj.companycode; //公司编码
      }
      wl.proType = obj.protype; //自产还是oem
      wl.cgprice = obj.cgprice; //采购价
      wl.cgmll = obj.cgmll; //采购毛利率
      wl.shareModelCode = null;
      wl.shareModelName = null;


      //售后单
      if (this.ddlx == '1,4') {
        wl.finalPrice = wl.proBenchmarkPrice;//成交价
      } else {
        wl.finalPrice = 0;//成交价
      }
      //如果是二级经销商 基准价*1.07 (暂只考虑标准订单) hyl
      if (this.ddlx == '1,2' && (wl.gscode == '9390' || wl.gscode == '9370' || wl.gscode == '1RK0')) {
        if (this.agentLevel == 2) {
          wl.proBenchmarkPrice = new big(wl.proBenchmarkPrice).times(1.07).toFixed(2).toString()
        }
      }


      wl.totalprice = 0;//产品总价
      wl.tjlist = obj.tjlist;//特价list
      wl.expoPrice = obj.expoPrice;
      wl.fromtype = obj.fromtype;

      //2021,12,28 zk 新增共享大类list
      wl.smList = obj.smList;

      //如果是样品机
      if (this.ddlx == '1,5') {
        wl.factory = obj.werks;

      } else {
        wl.factory = obj.factory;
      }
      //如果是免费订单 公司根据工厂判断
      if (this.ddlx == '1,6') {
        this.companyInfoList.forEach((obj) => {
          //根据工厂判断公司
          if (wl.factory == obj.refid) {
            wl.gscode = obj.code
          }
        })
        //原逻辑删除mark
      }

      wl.cpdlcode = obj.cpdlcode;

      wl.xiaoe = obj.xiaoe;
      wl.jishu = obj.jishu;
      wl.lianqun = obj.lianqun;
      wl.oemDesc = obj.oemDesc;

      //标准订单，特价订单，工程订单，获取对应漏斗数量
      if (this.ddlx == '1,1' || this.ddlx == '1,2' || this.ddlx == '1,11') {
        wl.num = obj.num;//漏斗数量
        wl.useNum = obj.useNum;//累计下单数量
        wl.proNumber = obj.num - obj.useNum;
        wl.funnelCode = obj.loudId;
        wl.funnelProductId = this.loudss.find(a => a.proCode == wl.materialCode).lpid;
      }

      return wl;
    },
    //选择地址
    selectAreadialog () {
      this.showdizhiflag = true;
    },
    choseDizhi (obj) {

      console.log("选中的地址", obj)
      this.order.addressCode = obj.id;
      this.order.areaId = obj.id;
      this.order.toAddress = obj.quobj.namepath;
      if (obj.zhenobj) {
        // this.order.toAddress = obj.zhenobj.namepath;
        obj.addrdetail = obj.zhenobj.name + "/" + obj.addrdetail;
      }
      this.order.toAddress = this.order.toAddress + "##" + obj.addrdetail

      this.order.toProvincesCode = obj.shengobj.code;
      this.order.toProvincesName = obj.shengobj.name;

      this.order.toCityCode = obj.shiobj.code;
      this.order.toCityName = obj.shiobj.name;

      this.showdizhiflag = false;


      //清空时间
      this.order.receivedTime = null;
      this.openReceivedTimedisabled = false;
      //根据地址，获取预计收货时间
      // ss.OrderMainService.getSendDays(obj.qu).then(rd => {
      //     console.log(rd);
      //     this.startDateLimit = _.assign({}, this.startDateLimit, {
      //         disabledDate: (time) => {
      //             return time.getTime() < new big(rd).plus(2).times(24 * 60 * 60 * 1000).plus(Date.now()).toString()
      //         }
      //     })
      // })
    },

    //直单用户修改公司 hyl
    chooseGsCode (code) {

      //将其他公司的数据赋值给选择的公司
      this.companyInfoList.forEach((obj) => {
        if (obj.code != code) {
          this['productlist' + obj.code].forEach((obj) => {
            this['productlist' + code].push(obj);
          })
          //清空其他公司信息
          this['productlist' + obj.code] = [];
        }
      })
      //将所有物料的公司编码改成选择的
      for (var i = 0; i < this['productlist' + code].length; i++) {
        this['productlist' + code][i].gscode = code;
      }


    },
    //获取收货单位
    showFormList (value) {
      // console.log("value188776676","111111111111111111111111")
      var data = value;
      console.log("value188776676", data)
      ss.OrderMainService.getCompanyInfo(value).then(rd => {
        this.addrList = rd;
      })
    },

    isStandardChange () {
      if (this.order.isStandard == 2) {
        this.$message('请上传投标参数及海尔配置清单');
      } else if (this.order.isStandard == 1) {
        this.$message('请上传海尔配置清单');
      }
    },

    //新增收货单位
    createAddress () {
      this.titleDig = "新建收货单位"
      this.institutionalX = true
      /*this.loadArea();*/
    },
    closeCompanyName (propData) {
      console.log(propData);
      this.closeDialog();
    },
    loadArea (i) {
      ss.Dictservice.arealist(this.proSelect).then(rd => {
        this.shenglist = rd;
        // for(let i = 0; i < this.shenglist.length; i++){
        //     this.shenglist[i].code = this.shenglist[i].code.substring(0,6);
        // }
        console.log("shenglist", this.shenglist)
      })
    },
    //取消
    exit () {
      this.closeDialog()
    },
    //关闭弹窗,清空数据
    closeDialog () {
      this.institutionalX = false
      this.newDialog = false
      this.updateDialog = false
      this.insertFlag = false
      this.reFlag = false
      //清空数据
      this.add.deptName = '';
      this.add.deptType = '';
      this.add.phone = '';
      this.add.leader = '';
      this.add.email = '';
      this.add.province = '';
      this.add.provinceId = '';
      this.add.city = '';
      this.add.cityId = '';
      this.add.area = '';
      this.add.areaId = '';
      this.add.landmark = '';
      this.add.address = '';
      this.add.parentCode = '';
      this.add.deptSourceChannel = '';
      this.stVal = null;
      this.add.schoolType = '';
    },
    closeLoudListDialog () {
      this.qLd.agentName = null;
      this.qLd.agentCode = null;
      this.qLd.customerChannel = null;
      this.qLd.ddlx = null;
      this.qLd.funnelCode = null;
      this.qLd.customerName = null;  //收货地址 与用户单位相同的
      //清空多选框  点击取消后清空
      this.$refs.multipleTable.clearSelection();
    },
    //省份选择器
    handleItemChange1 (o) {
      this.add.provinceId = o;
      this.address = _.find(this.shenglist, { code: this.add.provinceId });
      this.add.province = this.address.name;
      ss.Dictservice.areaTreelist({ code: o }).then(rd => {
        console.log("rddddddd", rd.zlist)
        this.add.city = '';
        this.add.area = '';
        this.arealist2 = rd.zlist;
        this.arealist3 = [];
      })
    },
    handleItemChange2 (o) {
      this.add.cityId = o;
      this.address = _.find(this.arealist2, { code: this.add.cityId });
      this.add.city = this.address.name;
      this.arealist3 = _.find(this.arealist2, { code: o }).zlist
      console.log("arealist3", this.arealist3)
      this.arealist4 = []
    },
    handleItemChange3 (o) {
      this.add.areaId = o;
      this.address = _.find(this.arealist3, { code: this.add.areaId });
      this.add.area = this.address.name;
    },
    commitCreate (v) {
      this.add.subFlag = '提交';
      this.add.countryId = '156';
      this.add.country = '中国';
      this.add.provinceId = this.add.provinceId.substring(0, 6);
      this.add.cityId = this.add.cityId.substring(0, 6);
      this.add.areaId = this.add.areaId.substring(0, 6);
      this.add.parentCode = this.stVal;

      var data = this.add;
      ss.nxAddress.insertAddress(data).then(rd => {
        this.closeDialog();
        this.query();
      })
    },
    //获取单位名称信息
    selectDept (value) {
      ss.nxAddress.getDeptList(value).then(rd => {
        this.deptNameList = rd.msg;
      })
    },
    //获取当前登录人创建的所有父级单位
    getParentInfo () {
      ss.nxAddress.getParentInfo().then(rd => {
        this.options = rd.msg;
      })
    },
    httpRequest2 (params) {
      console.log(params, "1111111111")
      const loading = this.$msg.loading("上传中...");
      uploadFile.upload(params.file, { companycode: this.testID, reftype: this.reftype2 }).then(rd => {
        console.log("上传完毕后", rd);
        loading.close();
        this.fileList2.unshift(rd.obj);
        this.idList.push(rd.obj.id);
        this.order.upload2.unshift("1");
      }).catch(error => {
        loading.close();
        this.fileList2.splice(0, 1);
        return Promise.reject(error);
      });
      return false;
    },
    handleRemove2 (file) {
      console.log(file, "aaaaa");
      //删除文件
      var id = file.id;
      uploadFile.deleteById(id).then(response => {
        // console.log(response,"删除")
      })
      //删除fileList数据
      // console.log(this.fileList);
      for (var i = 0; i < this.fileList2.length; i++) {
        if (this.fileList2[i].id === id) {
          this.fileList2.splice(i, 1);
          // console.log(this.fileList)
        }
      }
    },
    beforeRemove (file) {
      if (file && file.status === "success") {
        return this.$confirm(`确定移除 ${file.name}？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        });
      }
    },
    beforeUpload (file) {
      const isFile = file.type === 'image/jpg' || file.type === 'image/png' || file.type === 'image/jpeg';
      if (!isFile) {
        this.$message.error('上传文件的格式只能是 JPG或PNG格式!');
        return false;
      }
    },
    adds () {
      var a = {
        billingStarttime: "",
        billingEndtime: "",
        proModelName: this.productlist1JC0[0].proModelName,
        shareModelCode: "",
        materialCode: this.productlist1JC0[0].materialCode,
        materialName: this.productlist1JC0[0].materialName,
        proNumber: new big(1),
        cwddh: "",
        currencyCode: this.productlist1JC0[0].currencyCode,
        priceType: "",
        proBenchmarkPrice: new big(0),
        finalPrice: new big(0),
        note1: "",
        taxRate: 1
      };
      this.productlist1JC0.push(a)
    },
    getRentPrice (priceType, index) {
      //租赁费的话,根据租赁类型和租赁天数获取租赁价格
      if (priceType == 'ZL01') {

        this.productlist1JC0[index].proBenchmarkPrice = 0;
      } else {
        //根据费用类型获取价格
        var data = {
          priceType: null,
          isShhm: 0,
          isJj: 0,
        }
        data.priceType = priceType;
        if (data.priceType == 'ZL05') {
          data.isJj = 1;
        } else if (data.priceType == 'ZL08') {
          data.isShhm = 1;
        }
        ss.contractService.selectByRentType(data).then(rd => {
          if (rd.f) {
            var list = rd.msg;
            this.productlist1JC0[index].proBenchmarkPrice = list[0].untiPrice;
          }
        })
      }
    },
    // 漏斗弹窗
    showLd () {
      if (!this.order.soldToCode) {
        this.$msg.msge("请先选择售达方信息！")
        return;
      }
      if (this.order.orderCategory1 != 7 && this.order.orderCategory1 != 9 && !this.order.customerChannelCode) {
        this.$msg.msge("请先选择客户渠道！")
        return;
      }
      if (!this.order.toCompanyname) {
        this.$msg.msge("请先选择收货单位！")
        return;
      }
      //如果渠道不为空，根据渠道和经销商编码获取漏斗信息
      // if (this.order.customerChannelCode && this.order.soldToCode) {
      //   // var data = {};
      //   // data.agentCode = this.order.soldToCode;
      //   // data.customerChannel = this.order.customerChannelCode;
      //   // data.ddlx = this.ddlx;
      //   // data.customerName = this.order.toCompanyname;
      //   debugger
      //   this.qLd.agentName = this.order.soldToName;
      //   this.qLd.agentCode = this.order.soldToCode;
      //   this.qLd.customerChannel = this.order.customerChannelCode;
      //   this.qLd.ddlx = this.ddlx;
      //   this.qLd.customerName = this.order.toCompanyname;   //收货地址 与用户单位相同的
      //   if (this.ddlx == '1,1') {
      //     this.qLd.xmcode = this.order.orderProjectCode;
      //   }
      //   ss.OrderMainService.selectByAgent(this.qLd).then(rd => {
      //     this.dataLd = rd.records;
      //     this.qLd.total = rd.total || 0;
      //     this.dialogLd = true;
      //   })
      // }
      // this.restLd();
      // this.getLoudList();// 获取漏斗信息
    },
    restLd () {
      // this.qLd= {
      //     pageNo: 1,
      //     pageSize: 10,
      //     total: 0,
      //     type: 1,
      //     agentName:this.order.soldToName,// 经销商
      //     status:'',// 状态
      //     funnelCode:'',//漏斗编码
      //     lianqun:'',//链群
      //     customerChannel:this.order.customerChannelCode,// 渠道
      //     loudProductId:""// 已选中ids
      // }
      this.qLd.funnelCode = '';
    },
    getLoudList () {
      // this.qLd.month= this.add.month;
      // this.qLd.monthUser= this.add.userCode;
      // this.qLd.loudProductId='';
      // if(this.add.bscUserMonthlyLoudDetails!=null)
      //     this.qLd.loudProductId= this.add.bscUserMonthlyLoudDetails.map(item=>{return item.loudProductId}).join(",");
      // let ts = this;
      debugger
      ss.OrderMainService.selectByAgent(this.qLd).then(rd => {
        this.dataLd = rd.records;
        this.qLd.total = rd.total || 0;
      })
    },
    addMx () {
      // var funnelCode = null
      // for (var i = 0; i < this.multipleSelectionLd.length; i++) {
      //   if (i == 0) {
      //     funnelCode = this.multipleSelectionLd[i].funnelCode;
      //   } else {
      //     funnelCode = funnelCode + ',' + this.multipleSelectionLd[i].funnelCode;
      //   }
      // }

      // if (funnelCode != "" && funnelCode != null) {
      var data = {};
      data.agentCode = this.order.soldToCode;
      data.customerChannel = this.order.customerChannelCode;
      data.funnelCode = this.order.funnelCode;
      data.ddlx = this.ddlx;
      data.funnelString = this.order.funnelCode;
      data.lpid = this.order.lpid;
      data.ids = this.order.ids;
      data.areaCode = this.salesregionName;
      if (this.ddlx == '1,1') {
        data.xmcode = this.order.orderProjectCode;
      }
      if (this.isedit != "1") {
        ss.OrderMainService.selectNxnewWl(data).then(rd => {
          if (rd.f) {
            this.choseWuliao1(rd.msg);
            this.dialogLd = false;
          }
        })
      }
    },
    handleSelectionChangeLd (val) {
      this.multipleSelectionLd = val;
    },
    //根据公司编码返回productlist
    getProductlist (code) {
      console.log("productlist" + code, this[`${'productlist' + code}`].length)
      return this['productlist' + code];
    },
    //根据公司编码返回OrderName
    getOrderName (code) {
      return this['order' + code];
    },
    //根据公司编码返回costList
    getCostList (code) {
      return this['costList' + code];
    },
    changeDeptName (val) {
      console.log("changeDeptName", val)
      //匹配省市区信息
      ss.nxAddress.getAddressByWl(val).then(rd => {
        if (rd.f == true) {
          this.add.provinceId = rd.msg.provinceId;
          this.add.province = rd.msg.province;
          this.add.cityId = rd.msg.cityId;
          this.add.city = rd.msg.city;
          this.add.areaId = rd.msg.areaId;
          this.add.area = rd.msg.area;
          this.add.address = rd.msg.address;
          this.handleItemChangeN(this.add.provinceId);
        }
      })
      //根据单位名称获取关键字
      ss.nxAddressKeywords.matchKeywords(val).then(rd => {
        if (rd.msg != null) {
          this.add.deptSourceChannel = rd.msg.channelCode;
          this.add.schoolTypeName = rd.msg.userUnit;
          this.matchChannel(rd.msg.channelCode)
        }
      })
    },
    matchChannel (value) {
      console.log("value", value)
      ss.nxAddress.getAddressTypeByChannel(value).then(rd => {
        this.addressTypeList = rd.msg;
        // this.add.schoolTypeName = '';
      })
    },
    //地址选择器-新
    handleItemChangeN (o) {
      this.address = _.find(this.shenglist, { code: this.add.provinceId });
      // this.add.province = this.address.name;
      ss.Dictservice.areaTreelist({ code: o }).then(rd => {
        this.arealist2 = rd.zlist;
        this.arealist3 = [];
        this.address = _.find(this.arealist2, { code: this.add.cityId });
        // this.add.city = this.address.name;
        this.arealist3 = _.find(this.arealist2, { code: o }).zlist
      })
    }

  },


}
</script>
<style scoped>
.queren {
  background-color: #006aca;
  color: white;
}

.anniu {
  display: flex;
  justify-content: center;
  align-items: center;
}

.zancun {
  background-color: #24b5b8;
  color: white;
}

.quxiao,
.zancun {
  width: 100px;
}

.jieguo {
  border-bottom: 1px solid rgb(238, 236, 236);
  display: flex;
}

.jieguo .jieguo_label {
  width: 2rem;
  text-align: right;
  background-color: #ebf5ff;
  font-size: 0.16rem;
  color: #616467;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0 0.05rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.jieguo .jieguo_value {
  width: 19%;
  font-size: 0.16rem;
  color: #616467;
  height: 0.4rem;
  line-height: 0.4rem;
  padding: 0px 8px;
}

img {
  width: 25px;
  padding: 5px 0;
}

.DshuR {
  width: 100%;
  height: 100%;
  border: none;
}

.n-xiao .h-formbLine .h-elformWrap-2,
.n-two .h-formbLine .h-elformWrap-2 {
  width: 33.333%;
}

.n-xiao .h-formbLine .h-elformWrap-z,
.n-two .h-formbLine .h-elformWrap-z {
  width: 29%;
}

.n-xiao .h-formbLine .h-elformWrap-m,
.n-two .h-formbLine .h-elformWrap-m {
  width: 2%;
}
</style>
<style>
.n-two .h-formbLine .el-form-item__content .el-select,
.n-two .el-form .h-formbLine .el-form-item__content .el-select {
  width: 0;
}

.n-xiao .h-formbLine .el-form-item__label,
.n-two .h-formbLine .el-form-item__label {
  width: 43%;
}

.n-xiao .h-formbLine .el-form-item__content,
.n-two .h-formbLine .el-form-item__content {
  width: 57%;
}

.ljjtablepaddings2 .h-tableInput .el-input__inner {
  padding: 0.05rem 0.1rem;
}

.ljjtablepaddings2 .h-tableInput .el-input__icon {
  line-height: 0.25rem;
}

.ljjtablepaddings2 .ljjsales .el-input__inner {
  height: 0.3rem;
  line-height: 0.3rem;
}

.w-newIcon .el-input__icon {
  line-height: 0.4rem !important;
}
</style>
<style scoped lang="scss">
.bottomTip {
  position: absolute;
  left: 49.7%;
  bottom: 0.3rem;
  transform: translateX(-50%);
  z-index: 999999;
}

.newtext {
  font-size: 0.28rem;
  color: white;
  position: absolute;
  top: 0.2rem;
  left: 50%;
  transform: translateX(-50%);
  font-weight: bold;
  text-shadow: 1px 1px 4px #2785e7;
  z-index: 2;
}

.leaderBox {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 99999;
  overflow: hidden;
  top: 0;
  left: 0;

  .leaderbg {
    width: 100%;
    height: 100%;
  }

  .createNxs {
    position: absolute;
    z-index: 1;
  }

  .createNx1 {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .createNxbtn {
    width: 1.9rem;
    height: 0.6rem;
    border: 0.03rem solid #ffffff;
    background-color: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    display: flex;
    justify-content: center;
    line-height: 0.5rem;
    position: absolute;
    z-index: 99;
    bottom: 0.75rem;
    left: 50%;
    transform: translateX(-50%);
    font-size: 0.27rem;
    letter-spacing: 2px;
    color: white;
    cursor: pointer;
  }

  .closeIt {
    width: 0.3rem;
    height: 0.4rem;
    position: absolute;
    top: 0.2rem;
    right: 0.2rem;
    cursor: pointer;
    z-index: 2;
  }
}
</style>

